function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/SessionApi";
import * as SessionAuthoringMemoModalComponent from "./SessionAuthoringMemoModalComponent";
import * as SessionAuthoringConfirmModalComponent from "./SessionAuthoringConfirmModalComponent";
import IntlMessage from '../commons/Intl';
import { Action, AuthoringInteraction, AuthoringSequence, Errors, Label, PresetScenarioGroup, QuizResults, SequenceActions, SequenceActionVibrationIntensity, SequenceObject, SequenceSorts, SequenceTriggers } from "../commons/IntlMessages";
import SequenceInstanceModel from "../models/session/SequenceInstanceModel";
import TimelineInstanceModel from "../models/session/TimelineInstanceModel";
import { TriggerType } from "../enum/TriggerType";
import { ActionType } from "../enum/ActionType";
import { MaterialTypes } from "../enum/MaterialTypes";
import { SequenceErrors } from "../enum/SequenceErrors";
import TriggerInfoInstanceModel from "../models/session/TriggerInfoInstanceModel";
import ActionInfoInstanceModel from "../models/session/ActionInfoInstanceModel";
import { InteractionErrors } from "../enum/InteractionErrors";
import InteractionInstanceModel from "../models/session/InteractionInstanceModel";
import { StatableActionType } from "../enum/StatableActionType";
import UploadMaterialInstanceModel from "../models/session/UploadMaterialInstanceModel";
import SequenceGroupInstanceModel from "../models/session/SequenceGroupInstanceModel";
import ActionConditionInfoInstanceModel from "../models/session/ActionConditionInfoInstanceModel";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // オーサリング編集モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 編集
   */

  Mode[Mode["Modify"] = 1] = "Modify";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 2] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * オーサリングモード
 */


export var AuthoringMode;

(function (AuthoringMode) {
  /**
   * シーケンス
   */
  AuthoringMode[AuthoringMode["Sequences"] = 0] = "Sequences";
  /**
   * インタラクション
   */

  AuthoringMode[AuthoringMode["Interactions"] = 1] = "Interactions";
})(AuthoringMode || (AuthoringMode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    /*
     * 待機(ms): 最小値
     */

    _this.waitMinTime = 500;
    /**
     * 待機(ms): 最大値
     */

    _this.waitMaxTime = 60000;
    /**
     * 待機(ms): ステップ値
     */

    _this.waitStepTime = 100;
    var newSequenceGroup = new SequenceGroupInstanceModel(1, "");
    var newTimeline = new TimelineInstanceModel(_this.props.sessionId);
    _this.state = {
      Modal: null,
      AuthoringMode: _this.props.authoringMode,
      CurrentGroup: newSequenceGroup,
      SequenceTimeline: newTimeline,
      Sequence: null,
      InteractionTimeline: newTimeline,
      Interaction: null,
      SavedSequenceTimeline: _this.cloneSequence(newTimeline),
      SavedInteractionTimeline: _this.cloneInteraction(newTimeline),
      IsMenuExpanded: false,
      SessionAuthoringMemoModalMode: SessionAuthoringMemoModalComponent.Mode.None,
      SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.None,
      ErrorMessages: []
    };

    _this.getTimeline();

    return _this;
  }
  /**
   * タイムライン情報取得
   */


  _createClass(MainComponent, [{
    key: "getTimeline",
    value: function getTimeline() {
      var _this2 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.GetTimeline(this.props.sessionId, function (timeline) {
        for (var i = 0; i < timeline.SequenceGroups.length; i++) {
          if (timeline.SequenceGroups[i].GroupName == null || timeline.SequenceGroups[i].GroupName == "") {
            timeline.SequenceGroups[i].GroupName = intl.format(AuthoringSequence.SequenceGroupDefaultPrefix) + timeline.SequenceGroups[i].GroupNo.toString();
          }

          if (i == 0) {
            timeline.SequenceGroups[i].GroupName += intl.format(AuthoringSequence.SequenceGroupDefaultPostfix);
          }
        }

        _this2.setState({
          SequenceTimeline: timeline,
          SavedSequenceTimeline: _this2.cloneSequence(timeline)
        }, function () {
          var currentGroup = timeline.SequenceGroups.length > 0 ? timeline.SequenceGroups[0] : _this2.state.CurrentGroup;

          _this2.setState({
            CurrentGroup: currentGroup,
            SequenceTimeline: timeline,
            IsMenuExpanded: timeline.SequenceGroups.length > 1
          }, function () {
            Api.GetTimelineForInteraction(_this2.props.sessionId, function (timeline) {
              _this2.setState({
                InteractionTimeline: timeline,
                SavedInteractionTimeline: _this2.cloneInteraction(timeline)
              }, function () {
                _this2.setState({
                  InteractionTimeline: timeline
                }, function () {
                  setTimeout(function () {
                    $("#overlay").fadeOut(300);
                  }, 500);
                });
              });
            });
          });
        });
      });
    }
    /**
     * オーサリングモード変更
     *
     * @param mode オーサリングモード
     */

  }, {
    key: "changeAuthoringMode",
    value: function changeAuthoringMode(mode) {
      this.setState({
        AuthoringMode: mode
      });
    }
    /**
     * タイムライン情報クローン処理
     */

  }, {
    key: "cloneSequence",
    value: function cloneSequence(timeline) {
      var newTimeline = new TimelineInstanceModel(timeline.SessionId);

      for (var i = 0; i < timeline.SequenceGroups.length; i++) {
        newTimeline.SequenceGroups.push(new SequenceGroupInstanceModel(timeline.SequenceGroups[i].GroupNo, timeline.SequenceGroups[i].GroupName));

        for (var j = 0; j < timeline.SequenceGroups[i].Sequences.length; j++) {
          newTimeline.SequenceGroups[i].Sequences.push(new SequenceInstanceModel(timeline.SequenceGroups[i].Sequences[j].GroupNo, j + 1));
          newTimeline.SequenceGroups[i].Sequences[j].Memo = timeline.SequenceGroups[i].Sequences[j].Memo;

          for (var k = 0; k < timeline.SequenceGroups[i].Sequences[j].Triggers.length; k++) {
            newTimeline.SequenceGroups[i].Sequences[j].Triggers.push(new TriggerInfoInstanceModel());
            newTimeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectId = timeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectId;
            newTimeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectName = timeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectName;
            newTimeline.SequenceGroups[i].Sequences[j].Triggers[k].TriggerType = timeline.SequenceGroups[i].Sequences[j].Triggers[k].TriggerType;
            newTimeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectId = timeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectId;
            newTimeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectName = timeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectName;
            newTimeline.SequenceGroups[i].Sequences[j].Triggers[k].Distance = timeline.SequenceGroups[i].Sequences[j].Triggers[k].Distance;
          }

          for (var k = 0; k < timeline.SequenceGroups[i].Sequences[j].Actions.length; k++) {
            newTimeline.SequenceGroups[i].Sequences[j].Actions.push(new ActionInfoInstanceModel());
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectId = timeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectId;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectName = timeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectName;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].ActionType = timeline.SequenceGroups[i].Sequences[j].Actions[k].ActionType;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsOn = timeline.SequenceGroups[i].Sequences[j].Actions[k].IsOn;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsToggle = timeline.SequenceGroups[i].Sequences[j].Actions[k].IsToggle;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].MotionName = timeline.SequenceGroups[i].Sequences[j].Actions[k].MotionName;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsLoop = timeline.SequenceGroups[i].Sequences[j].Actions[k].IsLoop;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Scale = timeline.SequenceGroups[i].Sequences[j].Actions[k].Scale;
            newTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsDefault = timeline.SequenceGroups[i].Sequences[j].Actions[k].IsDefault;

            for (var l = 0; l < timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions.length; l++) {
              newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions.push(new ActionConditionInfoInstanceModel());
              newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ConditionNo = timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ConditionNo;
              newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].Condition = timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].Condition;
              newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionType = timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionType;
              newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].IsOn = timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].IsOn;
              newTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionValue = timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionValue;
            }
          }
        }
      }

      return newTimeline;
    }
    /**
     * タイムライン情報クローン処理
     */

  }, {
    key: "cloneSequenceGroup",
    value: function cloneSequenceGroup(no, name, sequences) {
      var newSequenceGroup = new SequenceGroupInstanceModel(no, name);

      for (var i = 0; i < sequences.length; i++) {
        newSequenceGroup.Sequences.push(new SequenceInstanceModel(no, i + 1));
        newSequenceGroup.Sequences[i].Memo = sequences[i].Memo;

        for (var j = 0; j < sequences[i].Triggers.length; j++) {
          newSequenceGroup.Sequences[i].Triggers.push(new TriggerInfoInstanceModel());
          newSequenceGroup.Sequences[i].Triggers[j].ObjectId = sequences[i].Triggers[j].ObjectId;
          newSequenceGroup.Sequences[i].Triggers[j].ObjectName = sequences[i].Triggers[j].ObjectName;
          newSequenceGroup.Sequences[i].Triggers[j].TriggerType = sequences[i].Triggers[j].TriggerType;
          newSequenceGroup.Sequences[i].Triggers[j].DependencyObjectId = sequences[i].Triggers[j].DependencyObjectId;
          newSequenceGroup.Sequences[i].Triggers[j].DependencyObjectName = sequences[i].Triggers[j].DependencyObjectName;
          newSequenceGroup.Sequences[i].Triggers[j].Distance = sequences[i].Triggers[j].Distance;
        }

        for (var j = 0; j < sequences[i].Actions.length; j++) {
          newSequenceGroup.Sequences[i].Actions.push(new ActionInfoInstanceModel());
          newSequenceGroup.Sequences[i].Actions[j].ObjectId = sequences[i].Actions[j].ObjectId;
          newSequenceGroup.Sequences[i].Actions[j].ObjectName = sequences[i].Actions[j].ObjectName;
          newSequenceGroup.Sequences[i].Actions[j].ActionType = sequences[i].Actions[j].ActionType;
          newSequenceGroup.Sequences[i].Actions[j].IsOn = sequences[i].Actions[j].IsOn;
          newSequenceGroup.Sequences[i].Actions[j].IsToggle = sequences[i].Actions[j].IsToggle;
          newSequenceGroup.Sequences[i].Actions[j].MotionName = sequences[i].Actions[j].MotionName;
          newSequenceGroup.Sequences[i].Actions[j].IsLoop = sequences[i].Actions[j].IsLoop;
          newSequenceGroup.Sequences[i].Actions[j].Scale = sequences[i].Actions[j].Scale;
          newSequenceGroup.Sequences[i].Actions[j].IsDefault = sequences[i].Actions[j].IsDefault;

          for (var k = 0; k < sequences[i].Actions[j].Conditions.length; k++) {
            newSequenceGroup.Sequences[i].Actions[j].Conditions.push(new ActionConditionInfoInstanceModel());
            newSequenceGroup.Sequences[i].Actions[j].Conditions[k].ConditionNo = sequences[i].Actions[j].Conditions[k].ConditionNo;
            newSequenceGroup.Sequences[i].Actions[j].Conditions[k].Condition = sequences[i].Actions[j].Conditions[k].Condition;
            newSequenceGroup.Sequences[i].Actions[j].Conditions[k].ActionType = sequences[i].Actions[j].Conditions[k].ActionType;
            newSequenceGroup.Sequences[i].Actions[j].Conditions[k].IsOn = sequences[i].Actions[j].Conditions[k].IsOn;
            newSequenceGroup.Sequences[i].Actions[j].Conditions[k].ActionValue = sequences[i].Actions[j].Conditions[k].ActionValue;
          }
        }
      }

      return newSequenceGroup;
    }
    /**
     * タイムライン情報クローン処理
     */

  }, {
    key: "cloneInteraction",
    value: function cloneInteraction(timeline) {
      var newTimeline = new TimelineInstanceModel(timeline.SessionId);

      for (var i = 0; i < timeline.Interactions.length; i++) {
        newTimeline.Interactions.push(new InteractionInstanceModel(i + 1));

        for (var j = 0; j < timeline.Interactions[i].Triggers.length; j++) {
          newTimeline.Interactions[i].Triggers.push(new TriggerInfoInstanceModel());
          newTimeline.Interactions[i].Triggers[j].ObjectId = timeline.Interactions[i].Triggers[j].ObjectId;
          newTimeline.Interactions[i].Triggers[j].ObjectName = timeline.Interactions[i].Triggers[j].ObjectName;
          newTimeline.Interactions[i].Triggers[j].TriggerType = timeline.Interactions[i].Triggers[j].TriggerType;
          newTimeline.Interactions[i].Triggers[j].DependencyObjectId = timeline.Interactions[i].Triggers[j].DependencyObjectId;
          newTimeline.Interactions[i].Triggers[j].DependencyObjectName = timeline.Interactions[i].Triggers[j].DependencyObjectName;
          newTimeline.Interactions[i].Triggers[j].Distance = timeline.Interactions[i].Triggers[j].Distance;
        }

        for (var j = 0; j < timeline.Interactions[i].Actions.length; j++) {
          newTimeline.Interactions[i].Actions.push(new ActionInfoInstanceModel());
          newTimeline.Interactions[i].Actions[j].ObjectId = timeline.Interactions[i].Actions[j].ObjectId;
          newTimeline.Interactions[i].Actions[j].ObjectName = timeline.Interactions[i].Actions[j].ObjectName;
          newTimeline.Interactions[i].Actions[j].ActionType = timeline.Interactions[i].Actions[j].ActionType;
          newTimeline.Interactions[i].Actions[j].IsOn = timeline.Interactions[i].Actions[j].IsOn;
          newTimeline.Interactions[i].Actions[j].IsToggle = timeline.Interactions[i].Actions[j].IsToggle;
          newTimeline.Interactions[i].Actions[j].MotionName = timeline.Interactions[i].Actions[j].MotionName;
          newTimeline.Interactions[i].Actions[j].IsLoop = timeline.Interactions[i].Actions[j].IsLoop;
          newTimeline.Interactions[i].Actions[j].Scale = timeline.Interactions[i].Actions[j].Scale;
          newTimeline.Interactions[i].Actions[j].IsDefault = timeline.Interactions[i].Actions[j].IsDefault;

          for (var k = 0; k < timeline.Interactions[i].Actions[j].Conditions.length; k++) {
            newTimeline.Interactions[i].Actions[j].Conditions.push(new ActionConditionInfoInstanceModel());
            newTimeline.Interactions[i].Actions[j].Conditions[k].ConditionNo = timeline.Interactions[i].Actions[j].Conditions[k].ConditionNo;
            newTimeline.Interactions[i].Actions[j].Conditions[k].Condition = timeline.Interactions[i].Actions[j].Conditions[k].Condition;
            newTimeline.Interactions[i].Actions[j].Conditions[k].ActionType = timeline.Interactions[i].Actions[j].Conditions[k].ActionType;
            newTimeline.Interactions[i].Actions[j].Conditions[k].IsOn = timeline.Interactions[i].Actions[j].Conditions[k].IsOn;
            newTimeline.Interactions[i].Actions[j].Conditions[k].ActionValue = timeline.Interactions[i].Actions[j].Conditions[k].ActionValue;
          }
        }
      }

      return newTimeline;
    }
    /**
     * ソート
     *
     * @param e
     */

  }, {
    key: "sort",
    value: function sort(e) {
      if (e.target.value == "") return;
      if (this.state.InteractionTimeline.Interactions.length == 0) return;
      var timeline = this.state.InteractionTimeline;

      switch (e.target.value) {
        case "0":
          timeline.Interactions = this.state.InteractionTimeline.Interactions.sort(function (a, b) {
            return a.Triggers[0].ObjectName.localeCompare(b.Triggers[0].ObjectName);
          });
          break;

        case "1":
          timeline.Interactions = this.state.InteractionTimeline.Interactions.sort(function (a, b) {
            return b.Triggers[0].ObjectName.localeCompare(a.Triggers[0].ObjectName);
          });
          break;

        case "2":
          timeline.Interactions = this.state.InteractionTimeline.Interactions.sort(function (a, b) {
            return a.Actions[0].ObjectName.localeCompare(b.Actions[0].ObjectName);
          });
          break;

        case "3":
          timeline.Interactions = this.state.InteractionTimeline.Interactions.sort(function (a, b) {
            return b.Actions[0].ObjectName.localeCompare(a.Actions[0].ObjectName);
          });
          break;
      }

      e.target.value = "";
      this.setState({
        InteractionTimeline: timeline
      });
    }
    /**
     * シーケンスの追加
     */

  }, {
    key: "addSequence",
    value: function addSequence() {
      var sequenceTimeline = this.state.SequenceTimeline;
      var groupNo = this.state.CurrentGroup.GroupNo;
      var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
        return s.GroupNo == groupNo;
      });

      if (groupIndex >= 0) {
        var sequence = new SequenceInstanceModel(sequenceTimeline.SequenceGroups[groupIndex].GroupNo, sequenceTimeline.SequenceGroups[groupIndex].Sequences.length + 1);
        sequence.Triggers.push(new TriggerInfoInstanceModel());
        sequence.Actions.push(new ActionInfoInstanceModel());
        sequenceTimeline.SequenceGroups[groupIndex].Sequences.push(sequence);
        this.setState({
          CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
          SequenceTimeline: sequenceTimeline
        });
      }
    }
    /**
     * シーケンスの挿入
     *
     * @param index インデックス
     */

  }, {
    key: "insertSequence",
    value: function insertSequence(index) {
      var sequenceTimeline = this.state.SequenceTimeline;
      var groupNo = this.state.CurrentGroup.GroupNo;
      var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
        return s.GroupNo == groupNo;
      });

      if (groupIndex >= 0) {
        var sequence = new SequenceInstanceModel(sequenceTimeline.SequenceGroups[groupIndex].GroupNo, index + 2);
        sequence.Triggers.push(new TriggerInfoInstanceModel());
        sequence.Actions.push(new ActionInfoInstanceModel());
        sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index + 1, 0, sequence);

        for (var i = index + 2; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences.length; i++) {
          sequenceTimeline.SequenceGroups[groupIndex].Sequences[i].No = i + 1;
        }

        this.setState({
          CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
          SequenceTimeline: sequenceTimeline
        });
      }
    }
    /**
     * シーケンスのクローン
     *
     * @param index インデックス
     */

  }, {
    key: "duplicateSequence",
    value: function duplicateSequence(index) {
      var sequenceTimeline = this.state.SequenceTimeline;
      var groupNo = this.state.CurrentGroup.GroupNo;
      var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
        return s.GroupNo == groupNo;
      });

      if (groupIndex >= 0) {
        var sequence = new SequenceInstanceModel(sequenceTimeline.SequenceGroups[groupIndex].GroupNo, index + 2);

        for (var i = 0; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers.length; i++) {
          var trigger = new TriggerInfoInstanceModel();
          trigger.ObjectId = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[i].ObjectId;
          trigger.ObjectName = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[i].ObjectName;
          trigger.TriggerType = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[i].TriggerType;
          trigger.DependencyObjectId = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[i].DependencyObjectId;
          trigger.DependencyObjectName = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[i].DependencyObjectName;
          trigger.Distance = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[i].Distance;
          sequence.Triggers.push(trigger);
        }

        for (var i = 0; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions.length; i++) {
          var action = new ActionInfoInstanceModel();
          action.ObjectId = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].ObjectId;
          action.ObjectName = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].ObjectName;
          action.ActionType = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].ActionType;
          action.IsOn = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].IsOn;
          action.IsToggle = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].IsToggle;
          action.MotionName = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].MotionName;
          action.IsLoop = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].IsLoop;
          action.Scale = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Scale;
          action.IsDefault = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].IsDefault;

          for (var j = 0; j < sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Conditions.length; j++) {
            var actionCondition = new ActionConditionInfoInstanceModel();
            actionCondition.ConditionNo = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Conditions[j].ConditionNo;
            actionCondition.Condition = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Conditions[j].Condition;
            actionCondition.ActionType = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Conditions[j].ActionType;
            actionCondition.IsOn = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Conditions[j].IsOn;
            actionCondition.ActionValue = sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[i].Conditions[j].ActionValue;
            action.Conditions.push(actionCondition);
          }

          sequence.Actions.push(action);
        }

        sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index + 1, 0, sequence);

        for (var i = index + 2; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences.length; i++) {
          sequenceTimeline.SequenceGroups[groupIndex].Sequences[i].No = i + 1;
        }

        this.setState({
          CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
          SequenceTimeline: sequenceTimeline
        });
      }
    }
    /**
     * シーケンスの削除
     *
     * @param index インデックス
     */

  }, {
    key: "deleteSequence",
    value: function deleteSequence(index) {
      var sequenceTimeline = this.state.SequenceTimeline;
      var groupNo = this.state.CurrentGroup.GroupNo;
      var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
        return s.GroupNo == groupNo;
      });

      if (groupIndex >= 0) {
        sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index, 1);

        for (var i = 0; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences.length; i++) {
          sequenceTimeline.SequenceGroups[groupIndex].Sequences[i].No = i + 1;
        }

        this.setState({
          CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
          SequenceTimeline: sequenceTimeline
        });
      }
    }
    /**
     * シーケンスの上移動
     *
     * @param index インデックス
     */

  }, {
    key: "upSequence",
    value: function upSequence(index) {
      var sequenceTimeline = this.state.SequenceTimeline;
      var groupNo = this.state.CurrentGroup.GroupNo;
      var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
        return s.GroupNo == groupNo;
      });

      if (groupIndex >= 0) {
        if (index == 0) return;
        sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index - 1, 0, sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index, 1)[0]);

        for (var i = 0; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences.length; i++) {
          sequenceTimeline.SequenceGroups[groupIndex].Sequences[i].No = i + 1;
        }

        this.setState({
          CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
          SequenceTimeline: sequenceTimeline
        });
      }
    }
    /**
     * シーケンスの下移動
     *
     * @param index インデックス
     */

  }, {
    key: "downSequence",
    value: function downSequence(index) {
      var sequenceTimeline = this.state.SequenceTimeline;
      var groupNo = this.state.CurrentGroup.GroupNo;
      var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
        return s.GroupNo == groupNo;
      });

      if (groupIndex >= 0) {
        if (index == sequenceTimeline.SequenceGroups[groupIndex].Sequences.length - 1) return;
        sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index + 1, 0, sequenceTimeline.SequenceGroups[groupIndex].Sequences.splice(index, 1)[0]);

        for (var i = 0; i < sequenceTimeline.SequenceGroups[groupIndex].Sequences.length; i++) {
          sequenceTimeline.SequenceGroups[groupIndex].Sequences[i].No = i + 1;
        }

        this.setState({
          CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
          SequenceTimeline: sequenceTimeline
        });
      }
    }
    /**
     * シーケンスの追加
     */

  }, {
    key: "addInteraction",
    value: function addInteraction() {
      var timeline = this.state.InteractionTimeline;
      var interaction = new InteractionInstanceModel(timeline.Interactions.length + 1);
      interaction.Triggers.push(new TriggerInfoInstanceModel());
      interaction.Actions.push(new ActionInfoInstanceModel());
      timeline.Interactions.push(interaction);
      this.setState({
        InteractionTimeline: timeline
      });
    }
    /**
     * シーケンスの挿入
     *
     * @param index インデックス
     */

  }, {
    key: "insertInteraction",
    value: function insertInteraction(index) {
      var timeline = this.state.InteractionTimeline;
      var interaction = new InteractionInstanceModel(index + 2);
      interaction.Triggers.push(new TriggerInfoInstanceModel());
      interaction.Actions.push(new ActionInfoInstanceModel());
      timeline.Interactions.splice(index + 1, 0, interaction);

      for (var i = index + 2; i < timeline.Interactions.length; i++) {
        timeline.Interactions[i].No = i + 1;
      }

      this.setState({
        InteractionTimeline: timeline
      });
    }
    /**
     * シーケンスのクローン
     *
     * @param index インデックス
     */

  }, {
    key: "duplicateInteraction",
    value: function duplicateInteraction(index) {
      var timeline = this.state.InteractionTimeline;
      var interaction = new InteractionInstanceModel(index + 2);

      for (var i = 0; i < timeline.Interactions[index].Triggers.length; i++) {
        var trigger = new TriggerInfoInstanceModel();
        trigger.ObjectId = timeline.Interactions[index].Triggers[i].ObjectId;
        trigger.ObjectName = timeline.Interactions[index].Triggers[i].ObjectName;
        trigger.TriggerType = timeline.Interactions[index].Triggers[i].TriggerType;
        trigger.DependencyObjectId = timeline.Interactions[index].Triggers[i].DependencyObjectId;
        trigger.DependencyObjectName = timeline.Interactions[index].Triggers[i].DependencyObjectName;
        trigger.Distance = timeline.Interactions[index].Triggers[i].Distance;
        interaction.Triggers.push(trigger);
      }

      for (var i = 0; i < timeline.Interactions[index].Actions.length; i++) {
        var action = new ActionInfoInstanceModel();
        action.ObjectId = timeline.Interactions[index].Actions[i].ObjectId;
        action.ObjectName = timeline.Interactions[index].Actions[i].ObjectName;
        action.ActionType = timeline.Interactions[index].Actions[i].ActionType;
        action.IsOn = timeline.Interactions[index].Actions[i].IsOn;
        action.IsToggle = timeline.Interactions[index].Actions[i].IsToggle;
        action.MotionName = timeline.Interactions[index].Actions[i].MotionName;
        action.IsLoop = timeline.Interactions[index].Actions[i].IsLoop;
        action.Scale = timeline.Interactions[index].Actions[i].Scale;
        action.IsDefault = timeline.Interactions[index].Actions[i].IsDefault;

        for (var j = 0; j < timeline.Interactions[index].Actions[i].Conditions.length; j++) {
          var actionCondition = new ActionConditionInfoInstanceModel();
          actionCondition.ConditionNo = timeline.Interactions[index].Actions[i].Conditions[j].ConditionNo;
          actionCondition.Condition = timeline.Interactions[index].Actions[i].Conditions[j].Condition;
          actionCondition.ActionType = timeline.Interactions[index].Actions[i].Conditions[j].ActionType;
          actionCondition.IsOn = timeline.Interactions[index].Actions[i].Conditions[j].IsOn;
          actionCondition.ActionValue = timeline.Interactions[index].Actions[i].Conditions[j].ActionValue;
          action.Conditions.push(actionCondition);
        }

        interaction.Actions.push(action);
      }

      timeline.Interactions.splice(index + 1, 0, interaction);

      for (var i = index + 2; i < timeline.Interactions.length; i++) {
        timeline.Interactions[i].No = i + 1;
      }

      this.setState({
        InteractionTimeline: timeline
      });
    }
    /**
     * シーケンスの削除
     *
     * @param index インデックス
     */

  }, {
    key: "deleteInteraction",
    value: function deleteInteraction(index) {
      var timeline = this.state.InteractionTimeline;
      timeline.Interactions.splice(index, 1);

      for (var i = 0; i < timeline.Interactions.length; i++) {
        timeline.Interactions[i].No = i + 1;
      }

      this.setState({
        InteractionTimeline: timeline
      });
    }
    /**
     * 登録時確認ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringRegisterConfirmModal",
    value: function openSessionAuthoringRegisterConfirmModal() {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.InteractionError
          });
          break;

        default:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.SequenceError
          });
          break;
      }
    }
    /**
     * キャンセル時確認ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringCancelConfirmModal",
    value: function openSessionAuthoringCancelConfirmModal() {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.InteractionConfirm
          });
          break;

        default:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.SequenceConfirm
          });
          break;
      }
    }
    /**
     * シーケンスグループ名前変更時登録ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringSequenceGroupRenameInputModal",
    value: function openSessionAuthoringSequenceGroupRenameInputModal() {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          break;

        default:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.SequenceGroupRenameInput
          });
          break;
      }
    }
    /**
     * シーケンスグループ複製時登録ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringSequenceGroupDuplicateInputModal",
    value: function openSessionAuthoringSequenceGroupDuplicateInputModal() {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          break;

        default:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.SequenceGroupDuplicateInput
          });
          break;
      }
    }
    /**
     * シーケンスグループ削除時確認ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringSequenceGroupDeleteConfirmModal",
    value: function openSessionAuthoringSequenceGroupDeleteConfirmModal() {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          break;

        default:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.SequenceGroupDeleteConfirm
          });
          break;
      }
    }
    /**
     * シーケンスグループ新規作成時登録ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringSequenceGroupCreateNewInputModal",
    value: function openSessionAuthoringSequenceGroupCreateNewInputModal() {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          break;

        default:
          this.setState({
            SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.SequenceGroupCreateNewInput
          });
          break;
      }
    }
    /**
     * 確認ダイアログモーダルで無視するを選択した際の処理を行います。
     */

  }, {
    key: "ignoreSessionAuthoringConfirmModal",
    value: function ignoreSessionAuthoringConfirmModal(closeEvent) {
      this.save(closeEvent);
    }
    /**
     * 確認ダイアログモーダルで登録するを選択した際の処理を行います。
     */

  }, {
    key: "inputSessionAuthoringConfirmModal",
    value: function inputSessionAuthoringConfirmModal(inputValue, closeEvent) {
      closeEvent();
      var value = inputValue !== null && inputValue !== void 0 ? inputValue : "";

      switch (this.state.SessionAuthoringConfirmModalMode) {
        case SessionAuthoringConfirmModalComponent.Mode.SequenceGroupRenameInput:
          var sequenceTimeline = this.state.SequenceTimeline;
          var no = this.state.CurrentGroup.GroupNo;

          if (no == 1) {
            value += intl.format(AuthoringSequence.SequenceGroupDefaultPostfix);
          }

          var index = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == no;
          });

          if (index >= 0) {
            sequenceTimeline.SequenceGroups[index].GroupName = value;
            sequenceTimeline.SequenceGroups[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[index],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;

        case SessionAuthoringConfirmModalComponent.Mode.SequenceGroupDuplicateInput:
          var sequenceTimeline = this.state.SequenceTimeline;
          var maxNo = 0;

          for (var i = 0; i < sequenceTimeline.SequenceGroups.length; i++) {
            if (maxNo < sequenceTimeline.SequenceGroups[i].GroupNo) {
              maxNo = sequenceTimeline.SequenceGroups[i].GroupNo;
            }
          }

          var groupNo = maxNo + 1;
          var groupName = value;
          var newSequenceGroup = this.cloneSequenceGroup(groupNo, groupName, this.state.CurrentGroup.Sequences);
          newSequenceGroup.hasChange = true;
          sequenceTimeline.SequenceGroups.push(newSequenceGroup);
          this.setState({
            CurrentGroup: newSequenceGroup,
            SequenceTimeline: sequenceTimeline
          });
          break;

        case SessionAuthoringConfirmModalComponent.Mode.SequenceGroupCreateNewInput:
          var sequenceTimeline = this.state.SequenceTimeline;
          var maxNo = 0;

          for (var i = 0; i < sequenceTimeline.SequenceGroups.length; i++) {
            if (maxNo < sequenceTimeline.SequenceGroups[i].GroupNo) {
              maxNo = sequenceTimeline.SequenceGroups[i].GroupNo;
            }
          }

          var groupNo = maxNo + 1;
          var groupName = value;
          var newSequenceGroup = new SequenceGroupInstanceModel(groupNo, groupName);
          newSequenceGroup.hasChange = true;
          sequenceTimeline.SequenceGroups.push(newSequenceGroup);
          this.setState({
            CurrentGroup: newSequenceGroup,
            SequenceTimeline: sequenceTimeline
          });
          break;

        default:
          this.closeModal();
          break;
      }
    }
    /**
     * 確認ダイアログモーダルで「はい」を選択した際の処理を行います。
     */

  }, {
    key: "yesSessionAuthoringConfirmModal",
    value: function yesSessionAuthoringConfirmModal(closeEvent) {
      closeEvent();

      switch (this.state.SessionAuthoringConfirmModalMode) {
        case SessionAuthoringConfirmModalComponent.Mode.SequenceGroupDeleteConfirm:
          if (this.state.CurrentGroup.GroupNo > 0) {
            var sequenceTimeline = this.state.SequenceTimeline;
            var no = this.state.CurrentGroup.GroupNo;
            var index = sequenceTimeline.SequenceGroups.findIndex(function (s) {
              return s.GroupNo == no;
            });

            if (index >= 0) {
              sequenceTimeline.SequenceGroups.splice(index, 1);

              if (index < sequenceTimeline.SequenceGroups.length) {
                this.setState({
                  CurrentGroup: sequenceTimeline.SequenceGroups[index],
                  SequenceTimeline: sequenceTimeline
                });
              } else {
                this.setState({
                  CurrentGroup: sequenceTimeline.SequenceGroups[this.state.SequenceTimeline.SequenceGroups.length - 1],
                  SequenceTimeline: sequenceTimeline
                });
              }
            }
          }

          break;

        default:
          this.closeModal();
          break;
      }
    }
    /**
     * 確認ダイアログモーダルで「いいえ」を選択した際の処理を行います。
     */

  }, {
    key: "noSessionAuthoringConfirmModal",
    value: function noSessionAuthoringConfirmModal(closeEvent) {
      closeEvent();
    }
    /**
     * 確認ダイアログモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionAuthoringConfirmModal",
    value: function hiddenSessionAuthoringConfirmModal() {
      this.setState({
        SessionAuthoringConfirmModalMode: SessionAuthoringConfirmModalComponent.Mode.None
      });
    }
    /**
     * メモ編集ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionAuthoringMemoModal",
    value: function openSessionAuthoringMemoModal(sequence, readOnly) {
      if (readOnly) {
        this.setState({
          Sequence: sequence,
          SessionAuthoringMemoModalMode: SessionAuthoringMemoModalComponent.Mode.ReadOnly
        });
      } else {
        this.setState({
          Sequence: sequence,
          SessionAuthoringMemoModalMode: SessionAuthoringMemoModalComponent.Mode.Edit
        });
      }
    }
    /**
     * メモ編集ダイアログモーダルで保存するを選択した際の処理を行います。
     */

  }, {
    key: "editSessionAuthoringMemoModal",
    value: function editSessionAuthoringMemoModal(memo, closeEvent) {
      if (this.state.Sequence == null) {
        closeEvent();
        return;
      }

      var sequence = this.state.Sequence;
      sequence.Memo = memo;
      this.setState({
        Sequence: sequence
      }, function () {
        closeEvent();
      });
    }
    /**
     * メモ編集ダイアログモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionAuthoringMemoModal",
    value: function hiddenSessionAuthoringMemoModal() {
      this.setState({
        Sequence: null,
        SessionAuthoringMemoModalMode: SessionAuthoringMemoModalComponent.Mode.None
      });
    }
    /**
     * エラー確認
     *
     * @param sequence シーケンス
     */

  }, {
    key: "checkErrorSequence",
    value: function checkErrorSequence(sequence, no) {
      if (sequence.Triggers.length == 0 || sequence.Actions.length == 0) return SequenceErrors.NoItemsSelected;
      if (no == 0 && (sequence.Triggers[0].TriggerType == TriggerType.Proximity || sequence.Triggers[0].TriggerType == TriggerType.Player || sequence.Triggers[0].TriggerType == TriggerType.Hand || sequence.Triggers[0].TriggerType == TriggerType.Gaze)) return SequenceErrors.TriggerSelectionErrorInFirstSequence;
      if (sequence.Triggers[0].ObjectName == null || sequence.Triggers[0].ObjectName == "" || sequence.Triggers[0].TriggerType == TriggerType.None) return SequenceErrors.NoItemsSelected;
      if (sequence.Triggers[0].TriggerType == TriggerType.Proximity && (sequence.Triggers[0].DependencyObjectName == null || sequence.Triggers[0].DependencyObjectName == "")) return SequenceErrors.NoItemsSelected;
      if (sequence.Actions[0].ObjectName == null || sequence.Actions[0].ObjectName == "" || sequence.Actions[0].ActionType == ActionType.None) return SequenceErrors.NoItemsSelected;

      if (sequence.Actions[0].ObjectName == "Controller") {
        if (sequence.Actions[0].ActionType == ActionType.Vibration && (sequence.Actions[0].MotionName == null || sequence.Actions[0].MotionName == "")) return SequenceErrors.NoItemsSelected;
        if (sequence.Actions[0].ActionType == ActionType.Vibration && (sequence.Actions[0].Scale == null || sequence.Actions[0].Scale == 0)) return SequenceErrors.NoItemsSelected;
      }

      if (sequence.Actions[0].ObjectName == "ScenarioGroup") {
        if (sequence.Actions[0].ActionType == ActionType.SwitchGroup && (sequence.Actions[0].MotionName == null || sequence.Actions[0].MotionName == "")) return SequenceErrors.NoItemsSelected;
      }

      if (sequence.Actions[0].ActionType == ActionType.ChatBot && sequence.Actions[0].IsOn && (sequence.Actions[0].MotionName == null || sequence.Actions[0].MotionName == "")) return SequenceErrors.NoItemsSelected;
      if (this.getSequenceMaterial(sequence).MaterialType == MaterialTypes.Panel && sequence.Actions[0].ActionType == ActionType.Visibility && sequence.Actions[0].IsOn && (sequence.Actions[0].MotionName == null || sequence.Actions[0].MotionName == "")) return SequenceErrors.NoItemsSelected;

      if (this.getSequenceMaterial(sequence).MaterialType == MaterialTypes.Panel && sequence.Actions[0].ActionType == ActionType.Visibility && sequence.Actions[0].IsOn && sequence.Actions[0].Conditions.length > 1) {
        for (var i = 0; i < sequence.Actions[0].Conditions.length; i++) {
          if (sequence.Actions[0].Conditions[i].ActionType != ActionType.SwitchGroup || sequence.Actions[0].Conditions[i].ActionType == ActionType.SwitchGroup && sequence.Actions[0].Conditions[i].IsOn == true && (sequence.Actions[0].Conditions[i].ActionValue == null || sequence.Actions[0].Conditions[i].ActionValue == "")) {
            return SequenceErrors.NoItemsSelected;
          }
        }
      }

      if (sequence.Actions[0].ActionType == ActionType.Scale && (sequence.Actions[0].Scale == null || sequence.Actions[0].Scale == 0 && !sequence.Actions[0].IsDefault)) return SequenceErrors.NoItemsSelected;
      if (sequence.Triggers[0].TriggerType == TriggerType.Proximity && sequence.Triggers[0].ObjectName == sequence.Triggers[0].DependencyObjectName) return SequenceErrors.SameItemsSelected;
      var materials = this.state.SequenceTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == sequence.Actions[0].ObjectName;
      });
      if (materials.length == 0) return SequenceErrors.NoError;
      var material = materials[0];
      if (material.MaterialType == MaterialTypes.Audio || material.MaterialType == MaterialTypes.Movie || material.MaterialType == MaterialTypes.ThreeDMovie || material.MaterialType == MaterialTypes.Live || material.MaterialType == MaterialTypes.Streaming) return SequenceErrors.NoError;
      if (material.MaterialType == MaterialTypes.Model && material.ItemCount == 0) return SequenceErrors.NoError;
      if (material.MaterialType == MaterialTypes.Document && material.ItemCount <= 1) return SequenceErrors.NoError;
      if (material.MaterialType == MaterialTypes.Panel && material.ItemCount == 0) return SequenceErrors.NoError;
      if (material.MaterialType == MaterialTypes.SphereGroup && material.ItemCount == 0) return SequenceErrors.NoError;
      if (sequence.Actions[0].ActionType == ActionType.Play && sequence.Actions[0].IsOn && (sequence.Actions[0].MotionName == null || sequence.Actions[0].MotionName == "")) return SequenceErrors.NoItemsSelected;
      return SequenceErrors.NoError;
    }
    /**
     * エラー確認
     *
     * @param interaction インタラクション
     */

  }, {
    key: "checkErrorInteraction",
    value: function checkErrorInteraction(interaction, no) {
      if (interaction.Triggers.length == 0 || interaction.Actions.length == 0) return InteractionErrors.NoItemsSelected;
      if (interaction.Triggers[0].ObjectName == null || interaction.Triggers[0].ObjectName == "" || interaction.Triggers[0].TriggerType == TriggerType.None) return InteractionErrors.NoItemsSelected;
      if (interaction.Triggers[0].TriggerType == TriggerType.Proximity && (interaction.Triggers[0].DependencyObjectName == null || interaction.Triggers[0].DependencyObjectName == "")) return InteractionErrors.NoItemsSelected;
      if (interaction.Actions[0].ObjectName == null || interaction.Actions[0].ObjectName == "" || interaction.Actions[0].ActionType == ActionType.None) return InteractionErrors.NoItemsSelected;

      if (interaction.Actions[0].ObjectName == "Controller") {
        if (interaction.Actions[0].ActionType == ActionType.Vibration && (interaction.Actions[0].MotionName == null || interaction.Actions[0].MotionName == "")) return InteractionErrors.NoItemsSelected;
        if (interaction.Actions[0].ActionType == ActionType.Vibration && (interaction.Actions[0].Scale == null || interaction.Actions[0].Scale == 0)) return InteractionErrors.NoItemsSelected;
      }

      if (interaction.Actions[0].ObjectName == "ScenarioGroup") {
        if (interaction.Actions[0].ActionType == ActionType.SwitchGroup && (interaction.Actions[0].MotionName == null || interaction.Actions[0].MotionName == "")) return InteractionErrors.NoItemsSelected;
      }

      if (this.getInteractionMaterial(interaction).MaterialType == MaterialTypes.Panel && interaction.Actions[0].ActionType == ActionType.Visibility && interaction.Actions[0].IsOn && interaction.Actions[0].Conditions.length > 1 && (interaction.Actions[0].Conditions[0].ActionType != ActionType.SwitchGroup || interaction.Actions[0].Conditions[0].ActionValue == null || interaction.Actions[0].Conditions[0].ActionValue == "" || interaction.Actions[0].Conditions[1].ActionType != ActionType.SwitchGroup || interaction.Actions[0].Conditions[1].ActionValue == null || interaction.Actions[0].Conditions[1].ActionValue == "")) {
        return InteractionErrors.NoItemsSelected;
      }

      if (interaction.Actions[0].ActionType == ActionType.ChatBot && (interaction.Actions[0].MotionName == null || interaction.Actions[0].MotionName == "")) return InteractionErrors.NoItemsSelected;
      if (this.getInteractionMaterial(interaction).MaterialType == MaterialTypes.Panel && interaction.Actions[0].ActionType == ActionType.Visibility && interaction.Actions[0].IsOn && (interaction.Actions[0].MotionName == null || interaction.Actions[0].MotionName == "")) return InteractionErrors.NoItemsSelected;

      if (this.getInteractionMaterial(interaction).MaterialType == MaterialTypes.Panel && interaction.Actions[0].ActionType == ActionType.Visibility && interaction.Actions[0].IsOn && interaction.Actions[0].Conditions.length > 1) {
        for (var i = 0; i < interaction.Actions[0].Conditions.length; i++) {
          if (interaction.Actions[0].Conditions[i].ActionType != ActionType.SwitchGroup || interaction.Actions[0].Conditions[i].ActionType == ActionType.SwitchGroup && interaction.Actions[0].Conditions[i].IsOn == true && (interaction.Actions[0].Conditions[i].ActionValue == null || interaction.Actions[0].Conditions[i].ActionValue == "")) {
            return InteractionErrors.NoItemsSelected;
          }
        }
      }

      if (this.getInteractionMaterial(interaction).MaterialType == MaterialTypes.DataPanel && interaction.Actions[0].ActionType == ActionType.Visibility && interaction.Actions[0].IsOn && (interaction.Actions[0].MotionName == null || interaction.Actions[0].MotionName == "")) return InteractionErrors.NoItemsSelected;
      if (interaction.Actions[0].ActionType == ActionType.Scale && (interaction.Actions[0].Scale == null || interaction.Actions[0].Scale == 0 && !interaction.Actions[0].IsDefault)) return InteractionErrors.NoItemsSelected;
      if (interaction.Triggers[0].TriggerType == TriggerType.Proximity && interaction.Triggers[0].ObjectName == interaction.Triggers[0].DependencyObjectName) return InteractionErrors.SameItemsSelected;
      var materials = this.state.InteractionTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == interaction.Actions[0].ObjectName;
      });
      if (materials.length == 0) return InteractionErrors.NoError;
      var material = materials[0];
      if (material.MaterialType == MaterialTypes.Audio || material.MaterialType == MaterialTypes.Movie || material.MaterialType == MaterialTypes.ThreeDMovie || material.MaterialType == MaterialTypes.Live || material.MaterialType == MaterialTypes.Streaming) return InteractionErrors.NoError;
      if (material.MaterialType == MaterialTypes.Model && material.ItemCount == 0) return InteractionErrors.NoError;
      if (material.MaterialType == MaterialTypes.Document) return InteractionErrors.NoError;
      if (material.MaterialType == MaterialTypes.Panel && material.ItemCount == 0) return InteractionErrors.NoError;
      if (material.MaterialType == MaterialTypes.DataPanel && material.ItemCount == 0) return InteractionErrors.NoError;
      if (material.MaterialType == MaterialTypes.SphereGroup && material.ItemCount == 0) return InteractionErrors.NoError;
      if (interaction.Actions[0].ActionType == ActionType.Play && (interaction.Actions[0].MotionName == null || interaction.Actions[0].MotionName == "")) return InteractionErrors.NoItemsSelected;
      return InteractionErrors.NoError;
    }
    /**
     * 変更確認
     *
     * @param sequence シーケンス
     */

  }, {
    key: "checkChangeSequence",
    value: function checkChangeSequence(timeline, savedTimeline) {
      if (timeline.SequenceGroups.length != savedTimeline.SequenceGroups.length) return true;

      for (var i = 0; i < timeline.SequenceGroups.length; i++) {
        if (timeline.SequenceGroups[i].GroupName != savedTimeline.SequenceGroups[i].GroupName) return true;
        if (timeline.SequenceGroups[i].Sequences.length != savedTimeline.SequenceGroups[i].Sequences.length) return true;

        for (var j = 0; j < timeline.SequenceGroups[i].Sequences.length; j++) {
          if (timeline.SequenceGroups[i].Sequences[j].Triggers.length != savedTimeline.SequenceGroups[i].Sequences[j].Triggers.length) return true;
          if (timeline.SequenceGroups[i].Sequences[j].Actions.length != savedTimeline.SequenceGroups[i].Sequences[j].Actions.length) return true;

          for (var k = 0; k < timeline.SequenceGroups[i].Sequences[j].Triggers.length; k++) {
            if (timeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectId != savedTimeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectId || timeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectName != savedTimeline.SequenceGroups[i].Sequences[j].Triggers[k].ObjectName || timeline.SequenceGroups[i].Sequences[j].Triggers[k].TriggerType != savedTimeline.SequenceGroups[i].Sequences[j].Triggers[k].TriggerType || timeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectId != savedTimeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectId || timeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectName != savedTimeline.SequenceGroups[i].Sequences[j].Triggers[k].DependencyObjectName || timeline.SequenceGroups[i].Sequences[j].Triggers[k].Distance != savedTimeline.SequenceGroups[i].Sequences[j].Triggers[k].Distance) return true;
          }

          for (var k = 0; k < timeline.SequenceGroups[i].Sequences[j].Actions.length; k++) {
            if (timeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectId != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectId || timeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectName != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].ObjectName || timeline.SequenceGroups[i].Sequences[j].Actions[k].ActionType != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].ActionType || timeline.SequenceGroups[i].Sequences[j].Actions[k].IsOn != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsOn || timeline.SequenceGroups[i].Sequences[j].Actions[k].IsToggle != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsToggle || timeline.SequenceGroups[i].Sequences[j].Actions[k].MotionName != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].MotionName || timeline.SequenceGroups[i].Sequences[j].Actions[k].IsLoop != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsLoop || timeline.SequenceGroups[i].Sequences[j].Actions[k].Scale != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].Scale || timeline.SequenceGroups[i].Sequences[j].Actions[k].IsDefault != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].IsDefault) return true;

            for (var l = 0; l < timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions.length; l++) {
              if (timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ConditionNo != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ConditionNo || timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].Condition != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].Condition || timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionType != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionType || timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].IsOn != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].IsOn || timeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionValue != savedTimeline.SequenceGroups[i].Sequences[j].Actions[k].Conditions[l].ActionValue) return true;
            }
          }
        }
      }

      return false;
    }
    /**
     * 変更確認
     *
     * @param timeline タイムライン
     * @param savedTimeline 保存されたタイムライン
     */

  }, {
    key: "checkChangeInteraction",
    value: function checkChangeInteraction(timeline, savedTimeline) {
      if (timeline.Interactions.length != savedTimeline.Interactions.length) return true;

      for (var i = 0; i < timeline.Interactions.length; i++) {
        if (timeline.Interactions[i].Triggers.length != savedTimeline.Interactions[i].Triggers.length) return true;
        if (timeline.Interactions[i].Actions.length != savedTimeline.Interactions[i].Actions.length) return true;

        for (var j = 0; j < timeline.Interactions[i].Triggers.length; j++) {
          if (timeline.Interactions[i].Triggers[j].ObjectId != savedTimeline.Interactions[i].Triggers[j].ObjectId || timeline.Interactions[i].Triggers[j].ObjectName != savedTimeline.Interactions[i].Triggers[j].ObjectName || timeline.Interactions[i].Triggers[j].TriggerType != savedTimeline.Interactions[i].Triggers[j].TriggerType || timeline.Interactions[i].Triggers[j].DependencyObjectId != savedTimeline.Interactions[i].Triggers[j].DependencyObjectId || timeline.Interactions[i].Triggers[j].DependencyObjectName != savedTimeline.Interactions[i].Triggers[j].DependencyObjectName || timeline.Interactions[i].Triggers[j].Distance != savedTimeline.Interactions[i].Triggers[j].Distance) return true;
        }

        for (var j = 0; j < timeline.Interactions[i].Actions.length; j++) {
          if (timeline.Interactions[i].Actions[j].ObjectId != savedTimeline.Interactions[i].Actions[j].ObjectId || timeline.Interactions[i].Actions[j].ObjectName != savedTimeline.Interactions[i].Actions[j].ObjectName || timeline.Interactions[i].Actions[j].ActionType != savedTimeline.Interactions[i].Actions[j].ActionType || timeline.Interactions[i].Actions[j].IsOn != savedTimeline.Interactions[i].Actions[j].IsOn || timeline.Interactions[i].Actions[j].IsToggle != savedTimeline.Interactions[i].Actions[j].IsToggle || timeline.Interactions[i].Actions[j].MotionName != savedTimeline.Interactions[i].Actions[j].MotionName || timeline.Interactions[i].Actions[j].IsLoop != savedTimeline.Interactions[i].Actions[j].IsLoop || timeline.Interactions[i].Actions[j].Scale != savedTimeline.Interactions[i].Actions[j].Scale || timeline.Interactions[i].Actions[j].IsDefault != savedTimeline.Interactions[i].Actions[j].IsDefault) return true;

          for (var k = 0; k < timeline.Interactions[i].Actions[j].Conditions.length; k++) {
            if (timeline.Interactions[i].Actions[j].Conditions[k].ConditionNo != savedTimeline.Interactions[i].Actions[j].Conditions[k].ConditionNo || timeline.Interactions[i].Actions[j].Conditions[k].Condition != savedTimeline.Interactions[i].Actions[j].Conditions[k].Condition || timeline.Interactions[i].Actions[j].Conditions[k].ActionType != savedTimeline.Interactions[i].Actions[j].Conditions[k].ActionType || timeline.Interactions[i].Actions[j].Conditions[k].IsOn != savedTimeline.Interactions[i].Actions[j].Conditions[k].IsOn || timeline.Interactions[i].Actions[j].Conditions[k].ActionValue != savedTimeline.Interactions[i].Actions[j].Conditions[k].ActionValue) return true;
          }
        }
      }

      return false;
    }
    /**
      * 保存
      */

  }, {
    key: "saveModal",
    value: function saveModal() {
      var _this3 = this;

      var error = false;
      var timeline = this.state.SequenceTimeline;

      for (var i = 0; i < timeline.SequenceGroups.length; i++) {
        for (var j = 0; j < timeline.SequenceGroups[i].Sequences.length; j++) {
          var sequence = timeline.SequenceGroups[i].Sequences[j];

          if (this.checkErrorSequence(sequence, j) > 0) {
            error = true;
          }
        }
      }

      this.setState({
        SequenceTimeline: timeline
      }, function () {
        if (error) {
          _this3.openSessionAuthoringRegisterConfirmModal();

          return;
        }

        error = false;
        timeline = _this3.state.InteractionTimeline;

        for (var i = 0; i < timeline.Interactions.length; i++) {
          var interaction = timeline.Interactions[i];

          if (_this3.checkErrorInteraction(interaction, i) > 0) {
            error = true;
          }
        }

        _this3.setState({
          InteractionTimeline: timeline
        }, function () {
          if (error) {
            _this3.openSessionAuthoringRegisterConfirmModal();

            return;
          }

          setTimeout(function () {
            $("#overlay").fadeIn();
          });

          _this3.save(function () {
            setTimeout(function () {
              $("#overlay").fadeOut(300);
            }, 500);
          });
        });
      });
    }
    /**
      * キャンセル
      */

  }, {
    key: "cancelModal",
    value: function cancelModal() {
      if (this.checkChangeSequence(this.state.SequenceTimeline, this.state.SavedSequenceTimeline)) {
        this.openSessionAuthoringCancelConfirmModal();
        return;
      }

      if (this.checkChangeInteraction(this.state.InteractionTimeline, this.state.SavedInteractionTimeline)) {
        this.openSessionAuthoringCancelConfirmModal();
        return;
      }

      this.closeModal();
    }
    /**
      * シーケンスの保存
      */

  }, {
    key: "save",
    value: function save(closeEvent) {
      var _this4 = this;

      var sequenceTimeline = this.state.SequenceTimeline;
      var postfix = intl.format(AuthoringSequence.SequenceGroupDefaultPostfix);

      if (sequenceTimeline.SequenceGroups[0].GroupName.endsWith(postfix)) {
        sequenceTimeline.SequenceGroups[0].GroupName = sequenceTimeline.SequenceGroups[0].GroupName.slice(0, -postfix.length);
      }

      var defaultName = intl.format(AuthoringSequence.SequenceGroupDefaultPostfix) + "1";

      if (sequenceTimeline.SequenceGroups[0].GroupName.endsWith(defaultName)) {
        sequenceTimeline.SequenceGroups[0].GroupName = sequenceTimeline.SequenceGroups[0].GroupName.slice(0, -defaultName.length);
      }

      var timelineModel = JSON.stringify(sequenceTimeline);
      Api.SetTimeline(timelineModel, function (result) {
        var timelineModel = JSON.stringify(_this4.state.InteractionTimeline);
        Api.SetTimelineForInteraction(timelineModel, function (result) {
          closeEvent();
          setTimeout(function () {
            $("#overlay").fadeOut(300);
          }, 500);

          _this4.closeModal();
        });
      });
    }
    /**
      * 閉じる
      */

  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this$state$Modal;

      (_this$state$Modal = this.state.Modal) === null || _this$state$Modal === void 0 ? void 0 : _this$state$Modal.modal('hide');
    }
    /**
     * トリガーオブジェクト更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateTriggerObject",
    value: function updateTriggerObject(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;

          if (interactionTimeline.Interactions[index].Triggers[0].ObjectName != e.target.value) {
            interactionTimeline.Interactions[index].Triggers[0].ObjectId = "";
            interactionTimeline.Interactions[index].Triggers[0].ObjectName = e.target.value;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName != e.target.value) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectId = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName = e.target.value;

              if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName == "Wait") {
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = TriggerType.Wait;
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].Distance = 500;
              } else if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName != "Wait" && sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType == TriggerType.Wait) {
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = TriggerType.None;
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].Distance = 0;
              }
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * トリガー依存関係オブジェクト更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateTriggerDependencyObject",
    value: function updateTriggerDependencyObject(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;

          if (interactionTimeline.Interactions[index].Triggers[0].DependencyObjectName != e.target.value) {
            interactionTimeline.Interactions[index].Triggers[0].DependencyObjectName = "";

            if (e.target.value != null) {
              if (e.target.value == "User") {
                interactionTimeline.Interactions[index].Triggers[0].TriggerType = TriggerType.Player;
              } else if (e.target.value == "Hand") {
                interactionTimeline.Interactions[index].Triggers[0].TriggerType = TriggerType.Hand;
              } else {
                interactionTimeline.Interactions[index].Triggers[0].TriggerType = TriggerType.Proximity;
                interactionTimeline.Interactions[index].Triggers[0].DependencyObjectId = "";
                interactionTimeline.Interactions[index].Triggers[0].DependencyObjectName = e.target.value;
              }
            }
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].DependencyObjectName != e.target.value) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].DependencyObjectName = "";

              if (e.target.value != null) {
                if (e.target.value == "User") {
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = TriggerType.Player;
                } else if (e.target.value == "Hand") {
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = TriggerType.Hand;
                } else {
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = TriggerType.Proximity;
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].DependencyObjectId = "";
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].DependencyObjectName = e.target.value;
                }
              }
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * トリガータイプ更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateTriggerType",
    value: function updateTriggerType(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Triggers[0].TriggerType = TriggerType.None;

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Triggers[0].TriggerType = Number(e.target.value);
          }

          if (interactionTimeline.Interactions[index].Triggers[0].TriggerType != TriggerType.Proximity && interactionTimeline.Interactions[index].Triggers[0].TriggerType != TriggerType.Player && interactionTimeline.Interactions[index].Triggers[0].TriggerType != TriggerType.Hand) {
            interactionTimeline.Interactions[index].Triggers[0].DependencyObjectId = "";
            interactionTimeline.Interactions[index].Triggers[0].DependencyObjectName = "";
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = TriggerType.None;

            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType = Number(e.target.value);
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType != TriggerType.Proximity && sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType != TriggerType.Player && sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType != TriggerType.Hand) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].DependencyObjectId = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].DependencyObjectName = "";
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType == TriggerType.Auto) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectId = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName = "Auto";
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType == TriggerType.Wait) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectId = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName = "Wait";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].Distance = 500;
            } else {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].Distance = 0;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * トリガー待機時間更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateTriggerWaitTime",
    value: function updateTriggerWaitTime(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Triggers[0].Distance = Number(e.target.value);
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].Distance = Number(e.target.value);
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクションオブジェクト更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionObject",
    value: function updateActionObject(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;

          if (interactionTimeline.Interactions[index].Actions[0].ObjectName != e.target.value) {
            interactionTimeline.Interactions[index].Actions[0].ObjectId = "";
            interactionTimeline.Interactions[index].Actions[0].ObjectName = e.target.value;
            interactionTimeline.Interactions[index].Actions[0].ActionType = ActionType.None;
            interactionTimeline.Interactions[index].Actions[0].MotionName = "";
            interactionTimeline.Interactions[index].Actions[0].IsOn = true;
            interactionTimeline.Interactions[index].Actions[0].IsLoop = false;
            interactionTimeline.Interactions[index].Actions[0].Scale = 0;
            interactionTimeline.Interactions[index].Actions[0].IsDefault = false;
            interactionTimeline.Interactions[index].Actions[0].Conditions.length = 0;
          }

          if (interactionTimeline.Interactions[index].Actions[0].ObjectName == "Controller") {
            interactionTimeline.Interactions[index].Actions[0].ActionType = ActionType.Vibration;
            interactionTimeline.Interactions[index].Actions[0].MotionName = "";
            interactionTimeline.Interactions[index].Actions[0].IsOn = true;
            interactionTimeline.Interactions[index].Actions[0].IsToggle = true;
            interactionTimeline.Interactions[index].Actions[0].IsLoop = false;
            interactionTimeline.Interactions[index].Actions[0].Scale = 0;
            interactionTimeline.Interactions[index].Actions[0].IsDefault = false;
          }

          if (interactionTimeline.Interactions[index].Actions[0].ObjectName == "ScenarioGroup") {
            interactionTimeline.Interactions[index].Actions[0].ActionType = ActionType.SwitchGroup;
            interactionTimeline.Interactions[index].Actions[0].MotionName = "";
            interactionTimeline.Interactions[index].Actions[0].IsOn = true;
            interactionTimeline.Interactions[index].Actions[0].IsToggle = true;
            interactionTimeline.Interactions[index].Actions[0].IsLoop = false;
            interactionTimeline.Interactions[index].Actions[0].Scale = 0;
            interactionTimeline.Interactions[index].Actions[0].IsDefault = false;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ObjectName != e.target.value) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ObjectId = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ObjectName = e.target.value;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ActionType = ActionType.None;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsOn = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsToggle = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 0;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.length = 0;
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].TriggerType == TriggerType.Auto) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectId = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Triggers[0].ObjectName = "Auto";
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ObjectName == "Controller") {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ActionType = ActionType.Vibration;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsOn = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsToggle = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 0;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ObjectName == "Wait") {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ActionType = ActionType.Wait;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsOn = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsToggle = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 500;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;
            }

            if (sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ObjectName == "ScenarioGroup") {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ActionType = ActionType.SwitchGroup;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsOn = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsToggle = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 0;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクションタイプ更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionType",
    value: function updateActionType(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].IsOn = true;
          interactionTimeline.Interactions[index].Actions[0].IsToggle = true;
          interactionTimeline.Interactions[index].Actions[0].ActionType = ActionType.None;

          if (e.target.value != null) {
            var isOn = Number(e.target.value) >= 100;
            var actionType = Number(e.target.value) >= 100 ? Number(e.target.value) - 100 : Number(e.target.value);
            interactionTimeline.Interactions[index].Actions[0].IsOn = isOn;
            interactionTimeline.Interactions[index].Actions[0].IsToggle = true;
            interactionTimeline.Interactions[index].Actions[0].ActionType = actionType;
            interactionTimeline.Interactions[index].Actions[0].MotionName = "";
            interactionTimeline.Interactions[index].Actions[0].IsLoop = false;
            interactionTimeline.Interactions[index].Actions[0].Scale = 0;
            interactionTimeline.Interactions[index].Actions[0].IsDefault = false;
            interactionTimeline.Interactions[index].Actions[0].Conditions.length = 0;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsOn = true;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ActionType = ActionType.None;

            if (e.target.value != null) {
              var _isOn = Number(e.target.value) >= 100;

              var _actionType = Number(e.target.value) >= 100 ? Number(e.target.value) - 100 : Number(e.target.value);

              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsOn = _isOn;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsToggle = true;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].ActionType = _actionType;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = "";
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 0;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.length = 0;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクションタイプトグル更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionTypeToggle",
    value: function updateActionTypeToggle(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].IsToggle = true;

          if (e.target.value != null) {
            var isToggle = Number(e.target.value) == 1 ? true : false;
            interactionTimeline.Interactions[index].Actions[0].IsToggle = isToggle;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (e.target.value != null) {
              var _isToggle = Number(e.target.value) == 1 ? true : false;

              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsToggle = _isToggle;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション待機時間更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionWaitTime",
    value: function updateActionWaitTime(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = Number(e.target.value);
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（モーション）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionMotion",
    value: function updateActionMotion(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].MotionName = e.target.value;
          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = e.target.value;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（メッセージ）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionMessage",
    value: function updateActionMessage(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].MotionName = e.target.value;
          interactionTimeline.Interactions[index].Actions[0].Conditions.length = 0;
          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = e.target.value;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.length = 0;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（ループ）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionLoop",
    value: function updateActionLoop(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].IsLoop = false;

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Actions[0].IsLoop = Number(e.target.value) == 1 ? true : false;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = false;

            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsLoop = Number(e.target.value) == 1 ? true : false;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（振動強度）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionVibrationIntensity",
    value: function updateActionVibrationIntensity(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].MotionName = "";

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Actions[0].MotionName = e.target.value;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = "";

            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = e.target.value;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（振動時間）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionVibrationTime",
    value: function updateActionVibrationTime(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].Scale = 0;
          interactionTimeline.Interactions[index].Actions[0].IsDefault = false;

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Actions[0].Scale = Number(e.target.value);
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 0;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;

            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = Number(e.target.value);
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（スケール）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionScale",
    value: function updateActionScale(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].Scale = 0;
          interactionTimeline.Interactions[index].Actions[0].IsDefault = false;

          if (e.target.value != null) {
            if (e.target.value == "IsDefault") {
              interactionTimeline.Interactions[index].Actions[0].Scale = 0;
              interactionTimeline.Interactions[index].Actions[0].IsDefault = true;
            } else {
              interactionTimeline.Interactions[index].Actions[0].Scale = Number(e.target.value);
              interactionTimeline.Interactions[index].Actions[0].IsDefault = false;
            }
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            if (e.target.value != null) {
              if (e.target.value == "IsDefault") {
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = 0;
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = true;
              } else {
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Scale = Number(e.target.value);
                sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].IsDefault = false;
              }
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（シナリオグループ）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionScenarioGroup",
    value: function updateActionScenarioGroup(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].MotionName = "";

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Actions[0].MotionName = e.target.value;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = e.target.value;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション（チャットボット）更新
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "updateActionChatBot",
    value: function updateActionChatBot(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].MotionName = e.target.value;
          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName = e.target.value;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * トリガー表示名を戻します。
     *
     * @param triggerType トリガータイプ
     */

  }, {
    key: "getTriggerTypeDisplayName",
    value: function getTriggerTypeDisplayName(triggerType) {
      switch (triggerType) {
        case 0:
          return intl.format(SequenceTriggers.Tap);

        case 1:
          return intl.format(SequenceTriggers.Gaze);

        case 3:
          return intl.format(SequenceTriggers.Proximity);

        case 4:
          return intl.format(SequenceTriggers.Auto);

        case 5:
          return intl.format(SequenceTriggers.Hand);

        case 6:
          return intl.format(SequenceTriggers.Data);

        default:
          return "";
      }
    }
    /**
     * アクション表示名を戻します。
     *
     * @param actionType アクションタイプ
     */

  }, {
    key: "getActionTypeDisplayName",
    value: function getActionTypeDisplayName(actionType) {
      switch (actionType) {
        case 100:
          return intl.format(SequenceActions.VisibilityOn);

        case 0:
          return intl.format(SequenceActions.VisibilityOff);

        case 101:
          return intl.format(SequenceActions.PlayOn);

        case 1:
          return intl.format(SequenceActions.PlayOff);

        case 102:
          return intl.format(SequenceActions.VoiceMemoOn);

        case 2:
          return intl.format(SequenceActions.VoiceMemoOff);

        case 103:
          return intl.format(SequenceActions.Reset);

        case 104:
          return intl.format(SequenceActions.Scale);

        case 4:
          return intl.format(SequenceActions.ScaleReset);

        case 105:
          return intl.format(SequenceActions.LockOn);

        case 5:
          return intl.format(SequenceActions.LockOff);

        case 106:
          return intl.format(SequenceActions.GravityOn);

        case 6:
          return intl.format(SequenceActions.GravityOff);

        case 107:
          return intl.format(SequenceActions.ChatBotOn);

        case 7:
          return intl.format(SequenceActions.ChatBotOff);

        case 108:
          return intl.format(SequenceActions.ImmersiveOn);

        case 8:
          return intl.format(SequenceActions.ImmersiveOff);

        case 109:
          return intl.format(SequenceActions.Gather);

        case 110:
          return intl.format(SequenceActions.Vibration);

        case 111:
          return intl.format(SequenceActions.Rollback);

        case 112:
          return intl.format(SequenceActions.Wait);

        case 113:
          return intl.format(SequenceActions.SwitchGroupOn);

        case 13:
          return intl.format(SequenceActions.SwitchGroupOff);

        default:
          return "";
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;

      var modal = $('#SessionAuthoringModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function (e) {
        _this5.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * 素材種別確認
     *
     * @param sequence シーケンス
     */

  }, {
    key: "getSequenceMaterial",
    value: function getSequenceMaterial(sequence) {
      var materials = this.state.SequenceTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == sequence.Actions[0].ObjectName;
      });
      if (materials.length == 0) return new UploadMaterialInstanceModel();
      return materials[0];
    }
    /**
     * アクション種別確認
     *
     * @param sequence シーケンス
     */

  }, {
    key: "getSequenceAction",
    value: function getSequenceAction(sequence) {
      return sequence.Actions[0];
    }
    /**
     * チャットボット可能確認
     *
     * @param sequence シーケンス
     */

  }, {
    key: "IsSequenceChatBot",
    value: function IsSequenceChatBot(sequence) {
      if (!this.state.SequenceTimeline.ChatBotOption) return false;
      if (this.state.SequenceTimeline.SituationList.length == 0) return false;
      var materials = this.state.SequenceTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == sequence.Actions[0].ObjectName;
      });
      if (materials.length == 0) return false;
      var material = materials[0];
      if (material.MaterialType == MaterialTypes.Model) return true;
      return false;
    }
    /**
     * 素材種別確認
     *
     * @param interaction インタラクション
     */

  }, {
    key: "getInteractionMaterial",
    value: function getInteractionMaterial(interaction) {
      var materials = this.state.InteractionTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == interaction.Actions[0].ObjectName;
      });
      if (materials.length == 0) return new UploadMaterialInstanceModel();
      return materials[0];
    }
    /**
     * アクション種別確認
     *
     * @param interaction インタラクション
     */

  }, {
    key: "getInteractionAction",
    value: function getInteractionAction(interaction) {
      return interaction.Actions[0];
    }
    /**
     * チャットボット可能確認
     *
     * @param interaction インタラクション
     */

  }, {
    key: "IsInteractionChatBot",
    value: function IsInteractionChatBot(interaction) {
      if (!this.state.InteractionTimeline.ChatBotOption) return false;
      if (this.state.InteractionTimeline.SituationList.length == 0) return false;
      var materials = this.state.InteractionTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == interaction.Actions[0].ObjectName;
      });
      if (materials.length == 0) return false;
      var material = materials[0];
      if (material.MaterialType == MaterialTypes.Model) return true;
      return false;
    }
    /**
     * シーケンスアクションリスト生成
     *
     * @param index
     * @param sequence
     */

  }, {
    key: "GenerateSequenceActions",
    value: function GenerateSequenceActions(index, sequence) {
      var _this6 = this;

      var actions = [];
      var material = this.getSequenceMaterial(sequence);
      var action = this.getSequenceAction(sequence);

      if (action.ObjectName == "Wait") {
        return /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("input", {
          type: "number",
          className: "authoringCont__number",
          min: this.waitMinTime,
          max: this.waitMaxTime,
          step: this.waitStepTime,
          disabled: this.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this6.updateActionWaitTime(index, e);
          },
          value: action.Scale
        }));
      } else {
        if (action.ObjectName == "Controller") {
          actions.push(StatableActionType.Vibration);
        } else if (action.ObjectName == "ScenarioGroup") {
          actions.push(StatableActionType.SwitchGroupOn);
        } else {
          switch (material.MaterialType) {
            case MaterialTypes.Empty:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              actions.push(StatableActionType.Gather);
              break;

            case MaterialTypes.Model:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);

              if (material.MaterialType == MaterialTypes.Model && material.ItemCount > 0) {
                actions.push(StatableActionType.PlayOn);
                actions.push(StatableActionType.PlayOff);
              }

              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              actions.push(StatableActionType.GravityOn);
              actions.push(StatableActionType.GravityOff);

              if (this.IsSequenceChatBot(sequence)) {
                actions.push(StatableActionType.ChatBotOn);
                actions.push(StatableActionType.ChatBotOff);
              }

              break;

            case MaterialTypes.PointCloud:
            case MaterialTypes.Lcc:
            case MaterialTypes.Map:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              actions.push(StatableActionType.GravityOn);
              actions.push(StatableActionType.GravityOff);
              break;

            case MaterialTypes.Movie:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.PlayOn);
              actions.push(StatableActionType.PlayOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              break;

            case MaterialTypes.ThreeDMovie:
            case MaterialTypes.SphereGroup:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.PlayOn);
              actions.push(StatableActionType.PlayOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              actions.push(StatableActionType.ImmersiveOn);
              actions.push(StatableActionType.ImmersiveOff);
              actions.push(StatableActionType.Gather);
              break;

            case MaterialTypes.Texture:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              break;

            case MaterialTypes.Document:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);

              if (material.MaterialType == MaterialTypes.Document && material.ItemCount > 0) {
                actions.push(StatableActionType.PlayOn);
                actions.push(StatableActionType.PlayOff);
              }

              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              break;

            case MaterialTypes.ThreeDTexture:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              actions.push(StatableActionType.ImmersiveOn);
              actions.push(StatableActionType.ImmersiveOff);
              actions.push(StatableActionType.Gather);
              break;

            case MaterialTypes.Audio:
              actions.push(StatableActionType.PlayOn);
              actions.push(StatableActionType.PlayOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              break;

            case MaterialTypes.Live:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.PlayOn);
              actions.push(StatableActionType.PlayOff);
              actions.push(StatableActionType.VoiceMemoOn);
              actions.push(StatableActionType.VoiceMemoOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              actions.push(StatableActionType.GravityOn);
              actions.push(StatableActionType.GravityOff);
              break;

            case MaterialTypes.Portal:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              break;

            case MaterialTypes.Empty:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              actions.push(StatableActionType.Rollback);
              actions.push(StatableActionType.Scale);
              actions.push(StatableActionType.LockOn);
              actions.push(StatableActionType.LockOff);
              break;

            case MaterialTypes.Panel:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              break;

            case MaterialTypes.Effect:
              actions.push(StatableActionType.VisibilityOn);
              actions.push(StatableActionType.VisibilityOff);
              break;

            default:
              break;
          }
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: this.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this6.updateActionType(index, e);
          },
          value: action.ActionType + (action.IsOn ? 100 : 0)
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectAction)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectAction)
        }, actions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y
          }, _this6.getActionTypeDisplayName(y));
        }))));
      }
    }
    /**
     * インタラクションアクションリスト生成
     *
     * @param interaction インタラクション
     */

  }, {
    key: "GenerateInteractionActions",
    value: function GenerateInteractionActions(index, interaction) {
      var _this7 = this;

      var actions = [];
      var material = this.getInteractionMaterial(interaction);
      var action = this.getInteractionAction(interaction);

      if (action.ObjectName == "Controller") {
        actions.push(StatableActionType.Vibration);
      } else if (action.ObjectName == "ScenarioGroup") {
        actions.push(StatableActionType.SwitchGroupOn);
      } else {
        switch (material.MaterialType) {
          case MaterialTypes.Empty:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            actions.push(StatableActionType.Gather);
            break;

          case MaterialTypes.Model:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);

            if (material.MaterialType == MaterialTypes.Model && material.ItemCount > 0) {
              actions.push(StatableActionType.PlayOn);
            }

            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            actions.push(StatableActionType.GravityOn);

            if (this.IsInteractionChatBot(interaction)) {
              actions.push(StatableActionType.ChatBotOn);
            }

            break;

          case MaterialTypes.PointCloud:
          case MaterialTypes.Lcc:
          case MaterialTypes.Map:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            actions.push(StatableActionType.GravityOn);
            break;

          case MaterialTypes.Movie:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.PlayOn);
            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            break;

          case MaterialTypes.ThreeDMovie:
          case MaterialTypes.SphereGroup:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.PlayOn);
            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            actions.push(StatableActionType.ImmersiveOn);
            actions.push(StatableActionType.Gather);
            break;

          case MaterialTypes.Texture:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            break;

          case MaterialTypes.Document:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);

            if (material.MaterialType == MaterialTypes.Document && material.ItemCount > 0) {
              actions.push(StatableActionType.PlayOn);
            }

            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            break;

          case MaterialTypes.ThreeDTexture:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            actions.push(StatableActionType.ImmersiveOn);
            actions.push(StatableActionType.Gather);
            break;

          case MaterialTypes.Audio:
            actions.push(StatableActionType.PlayOn);
            actions.push(StatableActionType.VoiceMemoOn);
            break;

          case MaterialTypes.Live:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.PlayOn);
            actions.push(StatableActionType.VoiceMemoOn);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            actions.push(StatableActionType.GravityOn);
            break;

          case MaterialTypes.Portal:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            break;

          case MaterialTypes.Empty:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            actions.push(StatableActionType.Rollback);
            actions.push(StatableActionType.Scale);
            actions.push(StatableActionType.LockOn);
            break;

          case MaterialTypes.Panel:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            break;

          case MaterialTypes.DataPanel:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            break;

          case MaterialTypes.Effect:
            actions.push(StatableActionType.VisibilityOn);
            actions.push(StatableActionType.VisibilityOff);
            break;

          default:
            break;
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__selectWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__selectRight"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__selectIcon"
      })), /*#__PURE__*/React.createElement("select", {
        className: "authoringCont__select",
        disabled: this.props.mode == Mode.ReadOnly,
        onChange: function onChange(e) {
          _this7.updateActionType(index, e);
        },
        value: action.ActionType + (action.IsOn ? 100 : 0)
      }, /*#__PURE__*/React.createElement("option", {
        className: "placeholder"
      }, intl.format(Action.SelectAction)), /*#__PURE__*/React.createElement("optgroup", {
        label: intl.format(Action.SelectAction)
      }, actions.map(function (y, j) {
        return /*#__PURE__*/React.createElement("option", {
          value: y
        }, _this7.getActionTypeDisplayName(y));
      }))));
    }
    /**
     * シーケンスグループのトグル制御
     */

  }, {
    key: "toggleSequenceGroup",
    value: function toggleSequenceGroup() {
      this.setState({
        IsMenuExpanded: !this.state.IsMenuExpanded
      });
    }
    /**
     * シーケンスグループの変更
     *
     * @param index インデックス
     * @param e イベントデータ
     */

  }, {
    key: "changeSequenceGroup",
    value: function changeSequenceGroup(e) {
      if (e.target.selectedIndex < 0) return;
      var sequenceTimeline = this.state.SequenceTimeline;
      this.setState({
        CurrentGroup: sequenceTimeline.SequenceGroups[e.target.selectedIndex]
      });
    }
    /**
     * シーケンスグループの名前の変更
     */

  }, {
    key: "renameSequenceGroup",
    value: function renameSequenceGroup() {
      this.openSessionAuthoringSequenceGroupRenameInputModal();
    }
    /**
     * シーケンスグループの追加
     */

  }, {
    key: "addSequenceGroup",
    value: function addSequenceGroup() {
      this.openSessionAuthoringSequenceGroupCreateNewInputModal();
    }
    /**
     * シーケンスグループの削除
     */

  }, {
    key: "deleteSequenceGroup",
    value: function deleteSequenceGroup() {
      this.openSessionAuthoringSequenceGroupDeleteConfirmModal();
    }
    /**
     * シーケンスグループの複製
     */

  }, {
    key: "duplicateSequenceGroup",
    value: function duplicateSequenceGroup() {
      this.openSessionAuthoringSequenceGroupDuplicateInputModal();
    }
    /**
     * 期間指定を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateActionIsBranch",
    value: function updateActionIsBranch(index, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;

          if (e.target.checked) {
            var items = this.getInteractionMaterial(interactionTimeline.Interactions[index]).Items.filter(function (i) {
              return i.ItemId == Number(interactionTimeline.Interactions[index].Actions[0].MotionName);
            });

            if (items.length > 0) {
              if (items[0].IsQuiz) {
                var correct = new ActionConditionInfoInstanceModel();
                correct.ConditionNo = 0;
                correct.Condition = "Corrent";
                correct.ActionType = ActionType.SwitchGroup;
                correct.IsOn = false;
                correct.ActionValue = "";
                interactionTimeline.Interactions[index].Actions[0].Conditions.push(correct);
                var incorrect = new ActionConditionInfoInstanceModel();
                incorrect.ConditionNo = 1;
                incorrect.Condition = "Incorrect";
                incorrect.ActionType = ActionType.SwitchGroup;
                incorrect.IsOn = false;
                incorrect.ActionValue = "";
                interactionTimeline.Interactions[index].Actions[0].Conditions.push(incorrect);
              } else {
                items[0].SelectItems.map(function (x, i) {
                  var correct = new ActionConditionInfoInstanceModel();
                  correct.ConditionNo = i;
                  correct.Condition = x;
                  correct.ActionType = ActionType.SwitchGroup;
                  correct.IsOn = false;
                  correct.ActionValue = "";
                  interactionTimeline.Interactions[index].Actions[0].Conditions.push(correct);
                });
              }
            }
          } else {
            interactionTimeline.Interactions[index].Actions[0].Conditions.length = 0;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var no = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == no;
          });

          if (groupIndex >= 0) {
            if (e.target.checked) {
              var _items = this.getSequenceMaterial(sequenceTimeline.SequenceGroups[groupIndex].Sequences[index]).Items.filter(function (i) {
                return i.ItemId == Number(sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].MotionName);
              });

              if (_items.length > 0) {
                if (_items[0].IsQuiz) {
                  var _correct = new ActionConditionInfoInstanceModel();

                  _correct.ConditionNo = 0;
                  _correct.Condition = "Corrent";
                  _correct.ActionType = ActionType.SwitchGroup;
                  _correct.IsOn = false;
                  _correct.ActionValue = "";
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.push(_correct);

                  var _incorrect = new ActionConditionInfoInstanceModel();

                  _incorrect.ConditionNo = 1;
                  _incorrect.Condition = "Incorrect";
                  _incorrect.ActionType = ActionType.SwitchGroup;
                  _incorrect.IsOn = false;
                  _incorrect.ActionValue = "";
                  sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.push(_incorrect);
                } else {
                  _items[0].SelectItems.map(function (x, i) {
                    var correct = new ActionConditionInfoInstanceModel();
                    correct.ConditionNo = i;
                    correct.Condition = x;
                    correct.ActionType = ActionType.SwitchGroup;
                    correct.IsOn = false;
                    correct.ActionValue = "";
                    sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.push(correct);
                  });
                }
              }
            } else {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions.length = 0;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション条件（シナリオグループ切り替え）更新
     *
     * @param index インデックス
     * @param no 番号
     * @param e イベントデータ
     */

  }, {
    key: "updateActionConditionSwitch",
    value: function updateActionConditionSwitch(index, no, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].Conditions[no].IsOn = false;
          interactionTimeline.Interactions[index].Actions[0].Conditions[no].ActionType = ActionType.None;

          if (e.target.value != null) {
            var isOn = Number(e.target.value) >= 100;
            var actionType = Number(e.target.value) >= 100 ? Number(e.target.value) - 100 : Number(e.target.value);
            interactionTimeline.Interactions[index].Actions[0].Conditions[no].IsOn = isOn;
            interactionTimeline.Interactions[index].Actions[0].Conditions[no].ActionType = actionType;
            interactionTimeline.Interactions[index].Actions[0].Conditions[no].ActionValue = "";
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].IsOn = false;
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].ActionType = ActionType.None;

            if (e.target.value != null) {
              var _isOn2 = Number(e.target.value) >= 100;

              var _actionType2 = Number(e.target.value) >= 100 ? Number(e.target.value) - 100 : Number(e.target.value);

              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].IsOn = _isOn2;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].ActionType = _actionType2;
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].ActionValue = "";
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

          break;
      }
    }
    /**
     * アクション条件（シナリオグループ）更新
     *
     * @param index インデックス
     * @param no 番号
     * @param e イベントデータ
     */

  }, {
    key: "updateActionConditionScenarioGroup",
    value: function updateActionConditionScenarioGroup(index, no, e) {
      switch (this.state.AuthoringMode) {
        case AuthoringMode.Interactions:
          var interactionTimeline = this.state.InteractionTimeline;
          interactionTimeline.Interactions[index].Actions[0].Conditions[no].ActionValue = "";

          if (e.target.value != null) {
            interactionTimeline.Interactions[index].Actions[0].Conditions[no].ActionValue = e.target.value;
          }

          interactionTimeline.Interactions[index].hasChange = true;
          this.setState({
            InteractionTimeline: interactionTimeline
          });
          break;

        default:
          var sequenceTimeline = this.state.SequenceTimeline;
          var groupNo = this.state.CurrentGroup.GroupNo;
          var groupIndex = sequenceTimeline.SequenceGroups.findIndex(function (s) {
            return s.GroupNo == groupNo;
          });

          if (groupIndex >= 0) {
            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].ActionValue = "";

            if (e.target.value != null) {
              sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].Actions[0].Conditions[no].ActionValue = e.target.value;
            }

            sequenceTimeline.SequenceGroups[groupIndex].Sequences[index].hasChange = true;
            this.setState({
              CurrentGroup: sequenceTimeline.SequenceGroups[groupIndex],
              SequenceTimeline: sequenceTimeline
            });
          }

      }
    }
    /**
     * 条件表示名取得
     *
     * @param condition 条件モデル
     * @param index インデックス
     */

  }, {
    key: "GetConditionDisplayName",
    value: function GetConditionDisplayName(action, index) {
      var messages = this.state.SequenceTimeline.Materials.filter(function (m) {
        return m.MaterialFileName == action.ObjectName;
      })[0].Items.filter(function (i) {
        return i.ItemId == Number(action.MotionName);
      });

      if (messages.length > 0 && messages[0].IsQuiz) {
        switch (index) {
          case 0:
            return intl.format(QuizResults.CorrectCase);

          case 1:
            return intl.format(QuizResults.IncorrectCase);
        }
      } else if (messages.length > 0 && index < messages[0].SelectItems.length) {
        return messages[0].SelectItems[index];
      }

      return action.Conditions[index].Condition;
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, this.state.AuthoringMode == AuthoringMode.Sequences && [/*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/Icon_Sequence_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringSequence.Title))), /*#__PURE__*/React.createElement("a", {
        href: "#",
        title: intl.format(AuthoringInteraction.Title),
        onClick: this.changeAuthoringMode.bind(this, AuthoringMode.Interactions)
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title modal-title-unselected"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "32",
        style: {
          marginTop: "5px"
        },
        src: "/assets/img/Icon_Interaction_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringInteraction.Title))))], this.state.AuthoringMode == AuthoringMode.Interactions && [/*#__PURE__*/React.createElement("a", {
        href: "#",
        title: intl.format(AuthoringInteraction.Title),
        onClick: this.changeAuthoringMode.bind(this, AuthoringMode.Sequences)
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title modal-title-unselected"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/Icon_Sequence_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringSequence.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "32",
        style: {
          marginTop: "5px"
        },
        src: "/assets/img/Icon_Interaction_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringInteraction.Title)))], /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        onClick: this.cancelModal.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 col-lg-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, this.state.AuthoringMode == AuthoringMode.Sequences && /*#__PURE__*/React.createElement("div", {
        className: "authoring"
      }, this.state.IsMenuExpanded && /*#__PURE__*/React.createElement("ul", {
        className: "authoringScenarioGroup"
      }, /*#__PURE__*/React.createElement("li", {
        className: "authoringScenarioGroup__item authoringScenarioGroup__label"
      }, intl.format(Label.EditScenarioGroup), ":"), /*#__PURE__*/React.createElement("li", {
        className: "authoringScenarioGroup__item authoringScenarioGroup__select"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__scenarioGroupSelectWrapper"
      }, /*#__PURE__*/React.createElement("select", {
        className: "authoringCont__select",
        onChange: function onChange(e) {
          _this8.changeSequenceGroup(e);
        },
        value: this.state.CurrentGroup.GroupNo
      }, this.state.SequenceTimeline.SequenceGroups.map(function (x, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: i,
          value: x.GroupNo
        }, x.GroupName);
      })), /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__selectRight"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__selectIcon"
      })))), /*#__PURE__*/React.createElement("li", {
        className: "authoringScenarioGroup__item authoringScenarioGroup__button"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__actionBtn",
        type: "button",
        disabled: this.props.mode == Mode.ReadOnly,
        onClick: this.renameSequenceGroup.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit_Grey.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Rename)))), /*#__PURE__*/React.createElement("li", {
        className: "authoringScenarioGroup__item authoringScenarioGroup__button"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__actionBtn",
        type: "button",
        disabled: this.props.mode == Mode.ReadOnly,
        onClick: this.duplicateSequenceGroup.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Duplicate_Grey.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Duplicate)))), /*#__PURE__*/React.createElement("li", {
        className: "authoringScenarioGroup__item authoringScenarioGroup__button"
      }, this.state.SequenceTimeline.SequenceGroups.length > 1 && this.state.CurrentGroup != null && this.state.CurrentGroup.GroupNo > 1 && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__actionBtn",
        type: "button",
        disabled: this.props.mode == Mode.ReadOnly,
        onClick: this.deleteSequenceGroup.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Delete_Grey.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Delete))), this.state.SequenceTimeline.SequenceGroups.length > 1 && (this.state.CurrentGroup == null || this.state.CurrentGroup.GroupNo == 1) && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__actionBtn",
        type: "button",
        disabled: true
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Delete_Grey.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Delete))), this.state.SequenceTimeline.SequenceGroups.length <= 1 && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__actionBtn",
        type: "button",
        onClick: this.toggleSequenceGroup.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Close_Grey.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Close)))), /*#__PURE__*/React.createElement("li", {
        className: "authoringScenarioGroup__item authoringScenarioGroup__button"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__actionBtn",
        type: "button",
        disabled: this.props.mode == Mode.ReadOnly,
        onClick: this.addSequenceGroup.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add_ScenarioGroup.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.CreateNew))))), /*#__PURE__*/React.createElement("ul", {
        className: "authoringHeader"
      }, /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TriggerObject)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TriggerAction)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TargetObject)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TargetAction)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TargetOption)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item--space"
      }), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item--space"
      }), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item--space"
      }), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, !this.state.IsMenuExpanded && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__groupBtn",
        type: "button",
        onClick: this.toggleSequenceGroup.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add_ScenarioGroup.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddScenarioGroup))))), /*#__PURE__*/React.createElement("div", {
        className: "authoringMain authoringMainSequence"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringConts"
      }, this.state.CurrentGroup.Sequences.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__contNoItemText"
      }, intl.format(AuthoringSequence.NoAuthoring)), this.state.CurrentGroup.Sequences.length > 0 && this.state.CurrentGroup.Sequences.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "authoringContSequence"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__title"
        }, intl.format(Label.Sequence), ":", ('000' + x.No).slice(-3), /*#__PURE__*/React.createElement("span", {
          className: "authoringCont__error"
        }, _this8.checkErrorSequence(x, i) == SequenceErrors.NoItemsSelected && intl.format(Errors.SelectRequired), _this8.checkErrorSequence(x, i) == SequenceErrors.SameItemsSelected && intl.format(Errors.SameItemsSelected), _this8.checkErrorSequence(x, i) == SequenceErrors.TriggerSelectionErrorInFirstSequence && intl.format(Errors.TriggerSelectionErrorInFirstSequence)), function () {
          var mode = _this8.props.mode;

          if (_this8.getSequenceMaterial(x).MaterialType != MaterialTypes.Panel) {
            return null;
          }

          var action = x.Actions[0];

          if (action.ActionType != ActionType.Visibility) {
            return null;
          }

          if (!action.IsOn) {
            return null;
          }

          if (action.ObjectName == null || action.ObjectName == "" || action.MotionName == null || action.MotionName == "") {
            return null;
          }

          var messages = _this8.state.SequenceTimeline.Materials.filter(function (m) {
            return m.MaterialFileName == action.ObjectName;
          })[0].Items.filter(function (i) {
            return i.ItemId == Number(action.MotionName);
          });

          if (messages.length == 0 || !messages[0].CanBranch && messages[0].SelectItems.length <= 1) {
            return null;
          }

          if (mode != Mode.ReadOnly) {
            return /*#__PURE__*/React.createElement("div", {
              className: "checkbox icheck-asbestos authoringCont__isbranch"
            }, /*#__PURE__*/React.createElement("label", {
              className: "",
              htmlFor: "isBranch"
            }, intl.format(Label.IsBranch)), /*#__PURE__*/React.createElement("input", {
              type: "checkbox",
              id: "isBranch",
              name: "isBranch",
              onChange: function onChange(e) {
                _this8.updateActionIsBranch(i, e);
              },
              checked: x.Actions[0].Conditions.length > 0
            }));
          } else {
            return /*#__PURE__*/React.createElement("div", {
              className: "checkbox icheck-asbestos authoringCont__isbranch"
            }, /*#__PURE__*/React.createElement("label", {
              className: "",
              htmlFor: "isBranch"
            }, intl.format(Label.IsBranch)), /*#__PURE__*/React.createElement("input", {
              type: "checkbox",
              id: "isBranch",
              name: "isBranch",
              disabled: true,
              checked: x.Actions[0].Conditions.length > 0
            }));
          }
        }()), /*#__PURE__*/React.createElement("ul", {
          className: "authoringCont__list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, (x.Triggers[0].TriggerType == TriggerType.None || x.Triggers[0].TriggerType == TriggerType.Tap || x.Triggers[0].TriggerType == TriggerType.Gaze || x.Triggers[0].TriggerType == TriggerType.Wait) && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerObject(i, e);
          },
          value: x.Triggers[0].ObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "TriggerObject"
        }, intl.format(SequenceObject.Empty)), /*#__PURE__*/React.createElement("option", {
          value: "Wait"
        }, intl.format(SequenceObject.Wait))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.SequenceTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        }))), (x.Triggers[0].TriggerType == TriggerType.Player || x.Triggers[0].TriggerType == TriggerType.Proximity || x.Triggers[0].TriggerType == TriggerType.Hand) && [/*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerObject(i, e);
          },
          value: x.Triggers[0].ObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "TriggerObject"
        }, intl.format(SequenceObject.Empty))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.SequenceTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerDependencyObject(i, e);
          },
          value: x.Triggers[0].TriggerType == TriggerType.Player ? "User" : x.Triggers[0].TriggerType == TriggerType.Hand ? "Hand" : x.Triggers[0].DependencyObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "User"
        }, intl.format(SequenceObject.User)), /*#__PURE__*/React.createElement("option", {
          value: "Hand"
        }, intl.format(SequenceObject.Hand))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.SequenceTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })))], x.Triggers[0].TriggerType == TriggerType.Auto && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: true
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, "-")), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, x.Triggers[0].TriggerType != TriggerType.Wait && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerType(i, e);
          },
          value: x.Triggers[0].TriggerType != TriggerType.Player && x.Triggers[0].TriggerType != TriggerType.Hand ? x.Triggers[0].TriggerType : TriggerType.Proximity
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTrigger)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTrigger)
        }, _this8.state.SequenceTimeline.TriggerTypeList.map(function (y, j) {
          if (y.Id !== TriggerType.Gaze && y.Id !== TriggerType.Data) {
            return /*#__PURE__*/React.createElement("option", {
              key: j,
              value: y.Id
            }, _this8.getTriggerTypeDisplayName(y.Id));
          }

          if (y.Id === TriggerType.Gaze && x.Triggers[0].TriggerType === TriggerType.Gaze) {
            return /*#__PURE__*/React.createElement("option", {
              key: j,
              value: y.Id
            }, _this8.getTriggerTypeDisplayName(y.Id));
          }

          return null;
        })))), x.Triggers[0].TriggerType == TriggerType.Wait && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("input", {
          type: "number",
          className: "authoringCont__number",
          min: _this8.waitMinTime,
          max: _this8.waitMaxTime,
          step: _this8.waitStepTime,
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerWaitTime(i, e);
          },
          value: x.Triggers[0].Distance
        })), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapperFirst"
          }, /*#__PURE__*/React.createElement("input", {
            type: "text",
            className: "authoringCont__label",
            disabled: true,
            value: _this8.GetConditionDisplayName(x.Actions[0], j)
          }));
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionObject(i, e);
          },
          value: x.Actions[0].ObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "Controller"
        }, intl.format(SequenceObject.Controller)), i == _this8.state.CurrentGroup.Sequences.length - 1 && /*#__PURE__*/React.createElement("option", {
          value: "ScenarioGroup"
        }, intl.format(SequenceObject.ScenarioGroup)), /*#__PURE__*/React.createElement("option", {
          value: "Wait"
        }, intl.format(SequenceObject.Wait))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.SequenceTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        })))), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapper"
          }, /*#__PURE__*/React.createElement("input", {
            type: "text",
            className: "authoringCont__label",
            disabled: true,
            value: intl.format(SequenceObject.ScenarioGroup)
          }));
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, _this8.GenerateSequenceActions(i, x), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectRight"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectIcon"
          })), /*#__PURE__*/React.createElement("select", {
            className: "authoringCont__select",
            disabled: _this8.props.mode == Mode.ReadOnly,
            onChange: function onChange(e) {
              _this8.updateActionConditionSwitch(i, j, e);
            },
            value: x.Actions[0].Conditions[j].ActionType + (x.Actions[0].Conditions[j].IsOn ? 100 : 0)
          }, /*#__PURE__*/React.createElement("option", {
            className: "placeholder"
          }, intl.format(Action.SelectAction)), /*#__PURE__*/React.createElement("optgroup", {
            label: intl.format(Action.SelectAction)
          }, /*#__PURE__*/React.createElement("option", {
            value: Number(StatableActionType.SwitchGroupOn)
          }, intl.format(SequenceActions.SwitchGroupOn)), /*#__PURE__*/React.createElement("option", {
            value: Number(StatableActionType.SwitchGroupOff)
          }, intl.format(SequenceActions.SwitchGroupOff)))));
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, _this8.getSequenceMaterial(x).MaterialType == MaterialTypes.Model && _this8.getSequenceAction(x).ActionType == ActionType.Play && _this8.getSequenceAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMotion(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectMotion)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectMotion)
        }, _this8.state.SequenceTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemName
          }, z.ItemName);
        })))), _this8.getSequenceMaterial(x).MaterialType == MaterialTypes.Model && _this8.getSequenceAction(x).ActionType == ActionType.ChatBot && _this8.getSequenceAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionChatBot(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectSituation)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectSituation)
        }, _this8.state.SequenceTimeline.SituationList.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.Source
          }, z.Source);
        })))), _this8.getSequenceMaterial(x).MaterialType == MaterialTypes.Document && _this8.getSequenceAction(x).ActionType == ActionType.Play && _this8.getSequenceAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMotion(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectPage)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectPage)
        }, _this8.state.SequenceTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemName
          }, z.ItemName);
        })))), _this8.getSequenceMaterial(x).MaterialType != MaterialTypes.Document && _this8.getSequenceAction(x).ActionType == ActionType.Play && _this8.getSequenceAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionLoop(i, e);
          },
          value: x.Actions[0].IsLoop ? "1" : "0"
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectLoop)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectLoop)
        }, /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, intl.format(Label.Loop), ":ON"), /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(Label.Loop), ":OFF")))), _this8.getSequenceMaterial(x).MaterialType == MaterialTypes.Panel && _this8.getSequenceAction(x).ActionType == ActionType.Visibility && _this8.getSequenceAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMessage(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectPanel)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectPanel)
        }, _this8.state.SequenceTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemId
          }, z.ItemName);
        })))), _this8.getSequenceAction(x).ActionType == ActionType.Scale && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionScale(i, e);
          },
          value: x.Actions[0].IsDefault ? "IsDefault" : x.Actions[0].Scale
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectScale)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectScale)
        }, /*#__PURE__*/React.createElement("option", {
          value: "IsDefault"
        }, "Default"), /*#__PURE__*/React.createElement("option", {
          value: "0.1"
        }, "x 1/10"), /*#__PURE__*/React.createElement("option", {
          value: "0.2"
        }, "x 1/5"), /*#__PURE__*/React.createElement("option", {
          value: "0.3"
        }, "x 1/3"), /*#__PURE__*/React.createElement("option", {
          value: "0.5"
        }, "x 1/2"), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, "x 1"), /*#__PURE__*/React.createElement("option", {
          value: "1.5"
        }, "x 1.5"), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, "x 2"), /*#__PURE__*/React.createElement("option", {
          value: "3"
        }, "x 3"), /*#__PURE__*/React.createElement("option", {
          value: "5"
        }, "x 5"), /*#__PURE__*/React.createElement("option", {
          value: "10"
        }, "x 10")))), _this8.getSequenceAction(x).ActionType == ActionType.Vibration && [/*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionVibrationIntensity(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectIntensity)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectIntensity)
        }, /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(SequenceActionVibrationIntensity.Weak)), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, intl.format(SequenceActionVibrationIntensity.Medium)), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, intl.format(SequenceActionVibrationIntensity.Strong))))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionVibrationTime(i, e);
          },
          value: x.Actions[0].Scale
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTime)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTime)
        }, /*#__PURE__*/React.createElement("option", {
          value: "0.5"
        }, intl.format(Label.Seconds, {
          time: "0.5"
        })), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, intl.format(Label.Seconds, {
          time: "1.0"
        })), /*#__PURE__*/React.createElement("option", {
          value: "3"
        }, intl.format(Label.Seconds, {
          time: "3.0"
        })))))], _this8.getSequenceAction(x).ActionType == ActionType.SwitchGroup && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionScenarioGroup(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectScenarioGroup)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectScenarioGroup)
        }, /*#__PURE__*/React.createElement("option", {
          value: -1
        }, intl.format(PresetScenarioGroup.CurrentTop)), /*#__PURE__*/React.createElement("option", {
          value: -2
        }, intl.format(PresetScenarioGroup.PreviousTop)), /*#__PURE__*/React.createElement("option", {
          value: -3
        }, intl.format(PresetScenarioGroup.PreviousBranch)), _this8.state.SequenceTimeline.SequenceGroups.filter(function (m) {
          return m.GroupNo != _this8.state.CurrentGroup.GroupNo;
        }).map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.GroupNo
          }, z.GroupName);
        })))), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectRight"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectIcon"
          })), /*#__PURE__*/React.createElement("select", {
            className: "authoringCont__select",
            disabled: _this8.props.mode == Mode.ReadOnly || !x.Actions[0].Conditions[j].IsOn,
            onChange: function onChange(e) {
              _this8.updateActionConditionScenarioGroup(i, j, e);
            },
            value: x.Actions[0].Conditions[j].ActionValue
          }, /*#__PURE__*/React.createElement("option", {
            className: "placeholder"
          }, intl.format(Action.SelectScenarioGroup)), /*#__PURE__*/React.createElement("optgroup", {
            label: intl.format(Action.SelectScenarioGroup)
          }, /*#__PURE__*/React.createElement("option", {
            value: -1
          }, intl.format(PresetScenarioGroup.CurrentTop)), /*#__PURE__*/React.createElement("option", {
            value: -2
          }, intl.format(PresetScenarioGroup.PreviousTop)), /*#__PURE__*/React.createElement("option", {
            value: -3
          }, intl.format(PresetScenarioGroup.PreviousBranch)), _this8.state.SequenceTimeline.SequenceGroups.filter(function (m) {
            return m.GroupNo != _this8.state.CurrentGroup.GroupNo;
          }).map(function (z, k) {
            return /*#__PURE__*/React.createElement("option", {
              value: z.GroupNo
            }, z.GroupName);
          }))));
        }), _this8.getSequenceMaterial(x).MaterialType == MaterialTypes.SphereGroup && (_this8.getSequenceAction(x).ActionType == ActionType.Visibility || _this8.getSequenceAction(x).ActionType == ActionType.Play) && _this8.getSequenceAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMotion(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, _this8.getSequenceAction(x).ActionType == ActionType.Play && /*#__PURE__*/React.createElement("option", {
          value: "CURRENTLY_SELECTED"
        }, intl.format(SequenceActions.CurrentlySelected)), _this8.state.SequenceTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemName
          }, z.ItemName);
        }))))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, function () {
          var mode = _this8.props.mode;
          var triggerType = x.Triggers[0].TriggerType;
          var objectName = x.Actions[0].ObjectName;
          var actionType = x.Actions[0].ActionType;

          if (triggerType == TriggerType.Auto || objectName == "ScenarioGroup" || actionType == ActionType.SwitchGroup) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--memo",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/memo_icon_disabled.svg"
            }));
          }

          if (x.Actions[0].Conditions.filter(function (c) {
            return c.IsOn;
          }).length == 2) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--memo",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/memo_icon_disabled.svg"
            }));
          }

          if (mode == Mode.ReadOnly) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--memo",
              type: "button",
              onClick: _this8.openSessionAuthoringMemoModal.bind(_this8, x, true)
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/memo_icon_disabled.svg"
            }));
          }

          return /*#__PURE__*/React.createElement("button", {
            className: "authoringCont__btn authoringCont__btn--memo",
            type: "button",
            onClick: _this8.openSessionAuthoringMemoModal.bind(_this8, x, false)
          }, /*#__PURE__*/React.createElement("img", {
            src: "/assets/img/memo_icon.svg"
          }));
        }()), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, function () {
          var mode = _this8.props.mode;
          var objectName = x.Actions[0].ObjectName;
          var actionType = x.Actions[0].ActionType;

          if (mode == Mode.ReadOnly || objectName == "ScenarioGroup" || actionType == ActionType.SwitchGroup) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--insert",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/seqadd_icon.svg"
            }));
          }

          if (x.Actions[0].Conditions.filter(function (c) {
            return c.IsOn;
          }).length == 2) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--insert",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/seqadd_icon.svg"
            }));
          }

          return /*#__PURE__*/React.createElement("button", {
            className: "authoringCont__btn authoringCont__btn--insert",
            type: "button",
            onClick: _this8.insertSequence.bind(_this8, i)
          }, /*#__PURE__*/React.createElement("img", {
            src: "/assets/img/seqadd_icon.svg"
          }));
        }()), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, function () {
          var mode = _this8.props.mode;
          var objectName = x.Actions[0].ObjectName;
          var actionType = x.Actions[0].ActionType;

          if (mode == Mode.ReadOnly || objectName == "ScenarioGroup" || actionType == ActionType.SwitchGroup) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--duplicate",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/clone_icon.svg"
            }));
          }

          if (x.Actions[0].Conditions.filter(function (c) {
            return c.IsOn;
          }).length == 2) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--duplicate",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/clone_icon.svg"
            }));
          }

          return /*#__PURE__*/React.createElement("button", {
            className: "authoringCont__btn authoringCont__btn--duplicate",
            type: "button",
            onClick: _this8.duplicateSequence.bind(_this8, i)
          }, /*#__PURE__*/React.createElement("img", {
            src: "/assets/img/clone_icon.svg"
          }));
        }()), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn",
          style: {
            width: "40px"
          }
        }, function () {
          var mode = _this8.props.mode;
          var objectName = x.Actions[0].ObjectName;
          var actionType = x.Actions[0].ActionType;

          if (mode == Mode.ReadOnly || objectName == "ScenarioGroup" || actionType == ActionType.SwitchGroup) {
            return /*#__PURE__*/React.createElement("div", {
              className: "authoringCont__btn authoringCont__btn--updown"
            }, /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--up",
              disabled: true,
              type: "button"
            }), /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--down",
              disabled: true,
              type: "button"
            }));
          }

          if (x.Actions[0].Conditions.filter(function (c) {
            return c.IsOn;
          }).length == 2) {
            return /*#__PURE__*/React.createElement("div", {
              className: "authoringCont__btn authoringCont__btn--updown"
            }, /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--up",
              disabled: true,
              type: "button"
            }), /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--down",
              disabled: true,
              type: "button"
            }));
          }

          if (i == 0) {
            return /*#__PURE__*/React.createElement("div", {
              className: "authoringCont__btn authoringCont__btn--updown"
            }, /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--up",
              disabled: true,
              type: "button"
            }), /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--down",
              type: "button",
              disabled: _this8.props.mode == Mode.ReadOnly,
              onClick: _this8.downSequence.bind(_this8, i)
            }));
          }

          if (i == _this8.state.CurrentGroup.Sequences.length - 1) {
            return /*#__PURE__*/React.createElement("div", {
              className: "authoringCont__btn authoringCont__btn--updown"
            }, /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--up",
              type: "button",
              disabled: _this8.props.mode == Mode.ReadOnly,
              onClick: _this8.upSequence.bind(_this8, i)
            }), /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--down",
              disabled: true,
              type: "button"
            }));
          }

          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__btn authoringCont__btn--updown"
          }, /*#__PURE__*/React.createElement("button", {
            className: "authoringCont__btn authoringCont__btn--up",
            type: "button",
            disabled: _this8.props.mode == Mode.ReadOnly,
            onClick: _this8.upSequence.bind(_this8, i)
          }), /*#__PURE__*/React.createElement("button", {
            className: "authoringCont__btn authoringCont__btn--down",
            type: "button",
            disabled: _this8.props.mode == Mode.ReadOnly,
            onClick: _this8.downSequence.bind(_this8, i)
          }));
        }()), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, function () {
          var mode = _this8.props.mode;

          if (mode == Mode.ReadOnly) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringCont__btn authoringCont__btn--del",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/delete_icon_red.svg"
            }));
          }

          return /*#__PURE__*/React.createElement("button", {
            className: "authoringCont__btn authoringCont__btn--del",
            type: "button",
            onClick: _this8.deleteSequence.bind(_this8, i)
          }, /*#__PURE__*/React.createElement("img", {
            src: "/assets/img/delete_icon_red.svg"
          }));
        }())));
      })), function () {
        var mode = _this8.props.mode;

        if (mode != Mode.ReadOnly) {
          var currentGroup = _this8.state.CurrentGroup;

          if (currentGroup.Sequences.length > 0 && (currentGroup.Sequences[currentGroup.Sequences.length - 1].Actions[0].ObjectName == "ScenarioGroup" && currentGroup.Sequences[currentGroup.Sequences.length - 1].Actions[0].ActionType == ActionType.SwitchGroup || currentGroup.Sequences[currentGroup.Sequences.length - 1].Actions[0].Conditions.length > 0 && currentGroup.Sequences[currentGroup.Sequences.length - 1].Actions[0].Conditions.filter(function (c) {
            return c.IsOn;
          }).length == currentGroup.Sequences[currentGroup.Sequences.length - 1].Actions[0].Conditions.length)) {
            return /*#__PURE__*/React.createElement("button", {
              className: "authoringMain__addBtn",
              type: "button",
              disabled: true
            }, /*#__PURE__*/React.createElement("img", {
              src: "/assets/img/Icon_Add.svg"
            }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Add)));
          }

          return /*#__PURE__*/React.createElement("button", {
            className: "authoringMain__addBtn",
            type: "button",
            onClick: _this8.addSequence.bind(_this8)
          }, /*#__PURE__*/React.createElement("img", {
            src: "/assets/img/Icon_Add.svg"
          }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Add)));
        }

        return null;
      }()), this.props.mode == Mode.Modify && /*#__PURE__*/React.createElement("div", {
        className: "authoringFotter"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringFotter__normal__btn",
        type: "button",
        onClick: this.cancelModal.bind(this)
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        className: "authoringFotter__primary__btn",
        type: "button",
        onClick: this.saveModal.bind(this)
      }, intl.format(Action.Entry))), this.props.mode != Mode.Modify && /*#__PURE__*/React.createElement("div", {
        className: "authoringFotter"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringFotter__primary__btn",
        type: "button",
        onClick: this.closeModal.bind(this)
      }, intl.format(Action.Close)))), this.state.AuthoringMode == AuthoringMode.Interactions && /*#__PURE__*/React.createElement("div", {
        className: "authoring"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringHeader"
      }, /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TriggerObject)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TriggerAction)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TargetObject)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TargetAction)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, intl.format(Label.TargetOption)), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item--space"
      }), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item--space"
      }), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item--space"
      }), /*#__PURE__*/React.createElement("li", {
        className: "authoringHeader__item"
      }, /*#__PURE__*/React.createElement("select", {
        className: "authoringCont__sort",
        onChange: function onChange(e) {
          _this8.sort(e);
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true,
        hidden: true
      }, intl.format(SequenceSorts.None)), /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(SequenceSorts.TriggerAz)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(SequenceSorts.TriggerZa)), /*#__PURE__*/React.createElement("option", {
        value: "2"
      }, intl.format(SequenceSorts.TargetAz)), /*#__PURE__*/React.createElement("option", {
        value: "3"
      }, intl.format(SequenceSorts.TargetZa))))), /*#__PURE__*/React.createElement("div", {
        className: "authoringMain authoringMainInteraction"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringConts"
      }, this.state.InteractionTimeline.Interactions.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "authoringCont__contNoItemText"
      }, intl.format(AuthoringInteraction.NoAuthoring)), this.state.InteractionTimeline.Interactions.length > 0 && this.state.InteractionTimeline.Interactions.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "authoringContInteraction"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__title"
        }, intl.format(Label.Interaction), ":", ('000' + x.No).slice(-3), /*#__PURE__*/React.createElement("span", {
          className: "authoringCont__error"
        }, _this8.checkErrorInteraction(x, i) == InteractionErrors.NoItemsSelected && intl.format(Errors.SelectRequired), _this8.checkErrorInteraction(x, i) == InteractionErrors.SameItemsSelected && intl.format(Errors.SameItemsSelected)), function () {
          var mode = _this8.props.mode;

          if (_this8.getInteractionMaterial(x).MaterialType != MaterialTypes.Panel) {
            return null;
          }

          var action = x.Actions[0];

          if (action.ActionType != ActionType.Visibility) {
            return null;
          }

          if (!action.IsOn) {
            return null;
          }

          if (action.ObjectName == null || action.ObjectName == "" || action.MotionName == null || action.MotionName == "") {
            return null;
          }

          var messages = _this8.state.InteractionTimeline.Materials.filter(function (m) {
            return m.MaterialFileName == action.ObjectName;
          })[0].Items.filter(function (i) {
            return i.ItemId == Number(action.MotionName);
          });

          if (messages.length == 0 || !messages[0].CanBranch && messages[0].SelectItems.length <= 1) {
            return null;
          }

          if (mode != Mode.ReadOnly) {
            return /*#__PURE__*/React.createElement("div", {
              className: "checkbox icheck-asbestos authoringCont__isbranch"
            }, /*#__PURE__*/React.createElement("label", {
              className: "",
              htmlFor: "isBranch"
            }, intl.format(Label.IsBranch)), /*#__PURE__*/React.createElement("input", {
              type: "checkbox",
              id: "isBranch",
              name: "isBranch",
              onChange: function onChange(e) {
                _this8.updateActionIsBranch(i, e);
              },
              checked: x.Actions[0].Conditions.length > 0
            }));
          } else {
            return /*#__PURE__*/React.createElement("div", {
              className: "checkbox icheck-asbestos authoringCont__isbranch"
            }, /*#__PURE__*/React.createElement("label", {
              className: "",
              htmlFor: "isBranch"
            }, intl.format(Label.IsBranch)), /*#__PURE__*/React.createElement("input", {
              type: "checkbox",
              id: "isBranch",
              name: "isBranch",
              disabled: true,
              checked: x.Actions[0].Conditions.length > 0
            }));
          }
        }()), /*#__PURE__*/React.createElement("ul", {
          className: "authoringCont__list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, (x.Triggers[0].TriggerType == TriggerType.None || x.Triggers[0].TriggerType == TriggerType.Tap || x.Triggers[0].TriggerType == TriggerType.Gaze) && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerObject(i, e);
          },
          value: x.Triggers[0].ObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "TriggerObject"
        }, intl.format(SequenceObject.Empty)), _this8.state.InteractionTimeline.DataIntegrationOption && /*#__PURE__*/React.createElement("option", {
          value: "DataPanel"
        }, intl.format(SequenceObject.DataPanel))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.InteractionTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        }))), (x.Triggers[0].TriggerType == TriggerType.Player || x.Triggers[0].TriggerType == TriggerType.Proximity || x.Triggers[0].TriggerType == TriggerType.Hand) && [/*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerObject(i, e);
          },
          value: x.Triggers[0].ObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "TriggerObject"
        }, intl.format(SequenceObject.Empty))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.InteractionTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerDependencyObject(i, e);
          },
          value: x.Triggers[0].TriggerType == TriggerType.Player ? "User" : x.Triggers[0].TriggerType == TriggerType.Hand ? "Hand" : x.Triggers[0].DependencyObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "User"
        }, intl.format(SequenceObject.User)), /*#__PURE__*/React.createElement("option", {
          value: "Hand"
        }, intl.format(SequenceObject.Hand))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.InteractionTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        }))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })))], x.Triggers[0].TriggerType == TriggerType.Auto && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: true
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, "-")), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateTriggerType(i, e);
          },
          value: x.Triggers[0].TriggerType != TriggerType.Player && x.Triggers[0].TriggerType != TriggerType.Hand ? x.Triggers[0].TriggerType : TriggerType.Proximity
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTrigger)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTrigger)
        }, _this8.state.InteractionTimeline.TriggerTypeList.map(function (y, j) {
          if (y.Id !== TriggerType.Gaze && y.Id !== TriggerType.Data) {
            return /*#__PURE__*/React.createElement("option", {
              key: j,
              value: y.Id
            }, _this8.getTriggerTypeDisplayName(y.Id));
          }

          if (y.Id === TriggerType.Gaze && x.Triggers[0].TriggerType === TriggerType.Gaze) {
            return /*#__PURE__*/React.createElement("option", {
              key: j,
              value: y.Id
            }, _this8.getTriggerTypeDisplayName(y.Id));
          }

          if (_this8.state.SequenceTimeline.DataIntegrationOption) {
            if (y.Id === TriggerType.Data) {
              return /*#__PURE__*/React.createElement("option", {
                key: j,
                value: y.Id
              }, _this8.getTriggerTypeDisplayName(y.Id));
            }
          } else {
            if (y.Id === TriggerType.Data && x.Triggers[0].TriggerType === TriggerType.Data) {
              return /*#__PURE__*/React.createElement("option", {
                key: j,
                value: y.Id
              }, _this8.getTriggerTypeDisplayName(y.Id));
            }
          }

          return null;
        })))), x.Triggers[0].TriggerType == TriggerType.Tap && (x.Actions[0].IsOn && _this8.getActionTypeDisplayName(x.Actions[0].ActionType) != "" && x.Actions[0].ActionType != ActionType.SwitchGroup || !x.Actions[0].IsOn && _this8.getActionTypeDisplayName(x.Actions[0].ActionType + 100) != "" && x.Actions[0].ActionType != ActionType.SwitchGroup) && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("input", {
          className: "authoringCont__input",
          type: "text",
          disabled: true,
          value: intl.format(SequenceTriggers.TapAgain)
        })), (x.Triggers[0].TriggerType == TriggerType.Player || x.Triggers[0].TriggerType == TriggerType.Proximity || x.Triggers[0].TriggerType == TriggerType.Hand) && (x.Actions[0].IsOn && _this8.getActionTypeDisplayName(x.Actions[0].ActionType) != "" && x.Actions[0].ActionType != ActionType.SwitchGroup || !x.Actions[0].IsOn && _this8.getActionTypeDisplayName(x.Actions[0].ActionType + 100) != "" && x.Actions[0].ActionType != ActionType.SwitchGroup) && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("input", {
          className: "authoringCont__input",
          type: "text",
          disabled: true,
          value: intl.format(SequenceTriggers.Leave)
        })), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapperFirst"
          }, /*#__PURE__*/React.createElement("input", {
            type: "text",
            className: "authoringCont__label",
            disabled: true,
            value: _this8.GetConditionDisplayName(x.Actions[0], j)
          }));
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionObject(i, e);
          },
          value: x.Actions[0].ObjectName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, /*#__PURE__*/React.createElement("option", {
          value: "Controller"
        }, intl.format(SequenceObject.Controller)), /*#__PURE__*/React.createElement("option", {
          value: "ScenarioGroup"
        }, intl.format(SequenceObject.ScenarioGroup)), _this8.state.InteractionTimeline.DataIntegrationOption && /*#__PURE__*/React.createElement("option", {
          value: "DataPanel"
        }, intl.format(SequenceObject.DataPanel))), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(SequenceObject.UploadFiles)
        }, _this8.state.InteractionTimeline.Materials.map(function (y, j) {
          return /*#__PURE__*/React.createElement("option", {
            value: y.MaterialFileName
          }, y.DisplayFileName);
        })))), x.Actions[0].Conditions.length > 0 && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapper"
          }, /*#__PURE__*/React.createElement("input", {
            type: "text",
            className: "authoringCont__label",
            disabled: true,
            value: intl.format(SequenceObject.ScenarioGroup)
          }));
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, _this8.GenerateInteractionActions(i, x), x.Actions[0].IsOn && _this8.getActionTypeDisplayName(x.Actions[0].ActionType) != "" && x.Actions[0].ActionType != ActionType.SwitchGroup && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionTypeToggle(i, e);
          },
          value: x.Actions[0].IsToggle ? "1" : "0"
        }, /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectAction)
        }, x.Triggers[0].TriggerType == TriggerType.Tap && /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(SequenceActions.SameAsAbove)), (x.Triggers[0].TriggerType == TriggerType.Proximity || x.Triggers[0].TriggerType == TriggerType.Player || x.Triggers[0].TriggerType == TriggerType.Hand) && /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(SequenceActions.DoNothing)), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, _this8.getActionTypeDisplayName(x.Actions[0].ActionType))))), !x.Actions[0].IsOn && _this8.getActionTypeDisplayName(x.Actions[0].ActionType + 100) != "" && x.Actions[0].ActionType != ActionType.SwitchGroup && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionTypeToggle(i, e);
          },
          value: x.Actions[0].IsToggle ? "1" : "0"
        }, /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectAction)
        }, x.Triggers[0].TriggerType == TriggerType.Tap && /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(SequenceActions.SameAsAbove)), (x.Triggers[0].TriggerType == TriggerType.Proximity || x.Triggers[0].TriggerType == TriggerType.Player || x.Triggers[0].TriggerType == TriggerType.Hand) && /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(SequenceActions.DoNothing)), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, _this8.getActionTypeDisplayName(x.Actions[0].ActionType + 100))))), x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectRight"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectIcon"
          })), /*#__PURE__*/React.createElement("select", {
            className: "authoringCont__select",
            disabled: _this8.props.mode == Mode.ReadOnly,
            onChange: function onChange(e) {
              _this8.updateActionConditionSwitch(i, j, e);
            },
            value: x.Actions[0].Conditions[j].ActionType + (x.Actions[0].Conditions[j].IsOn ? 100 : 0)
          }, /*#__PURE__*/React.createElement("option", {
            className: "placeholder"
          }, intl.format(Action.SelectAction)), /*#__PURE__*/React.createElement("optgroup", {
            label: intl.format(Action.SelectAction)
          }, /*#__PURE__*/React.createElement("option", {
            value: Number(StatableActionType.SwitchGroupOn)
          }, intl.format(SequenceActions.SwitchGroupOn)), /*#__PURE__*/React.createElement("option", {
            value: Number(StatableActionType.SwitchGroupOff)
          }, intl.format(SequenceActions.SwitchGroupOff)))));
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, _this8.getInteractionMaterial(x).MaterialType == MaterialTypes.Model && _this8.getInteractionAction(x).ActionType == ActionType.Play && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMotion(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectMotion)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectMotion)
        }, _this8.state.InteractionTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemName
          }, z.ItemName);
        })))), _this8.getInteractionMaterial(x).MaterialType == MaterialTypes.Model && _this8.getInteractionAction(x).ActionType == ActionType.ChatBot && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionChatBot(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectSituation)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectSituation)
        }, _this8.state.InteractionTimeline.SituationList.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.Source
          }, z.Source);
        })))), _this8.getInteractionMaterial(x).MaterialType == MaterialTypes.Document && _this8.getInteractionAction(x).ActionType == ActionType.Play && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("input", {
          className: "authoringCont__input",
          type: "text",
          disabled: true,
          value: intl.format(SequenceActions.NextPage)
        })), _this8.getInteractionMaterial(x).MaterialType != MaterialTypes.Document && _this8.getInteractionAction(x).ActionType == ActionType.Play && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionLoop(i, e);
          },
          value: x.Actions[0].IsLoop ? "1" : "0"
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectLoop)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectLoop)
        }, /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, intl.format(Label.Loop), ":ON"), /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(Label.Loop), ":OFF")))), _this8.getInteractionMaterial(x).MaterialType == MaterialTypes.Panel && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMessage(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectPanel)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectPanel)
        }, _this8.state.InteractionTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemId
          }, z.ItemName);
        })))), _this8.getInteractionMaterial(x).MaterialType == MaterialTypes.DataPanel && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMotion(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectPanel)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectPanel)
        }, _this8.state.InteractionTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemId
          }, z.ItemName);
        })))), _this8.getInteractionAction(x).ActionType == ActionType.Scale && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionScale(i, e);
          },
          value: x.Actions[0].IsDefault ? "IsDefault" : x.Actions[0].Scale
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectScale)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectScale)
        }, /*#__PURE__*/React.createElement("option", {
          value: "IsDefault"
        }, "Default"), /*#__PURE__*/React.createElement("option", {
          value: "0.1"
        }, "x 1/10"), /*#__PURE__*/React.createElement("option", {
          value: "0.2"
        }, "x 1/5"), /*#__PURE__*/React.createElement("option", {
          value: "0.3"
        }, "x 1/3"), /*#__PURE__*/React.createElement("option", {
          value: "0.5"
        }, "x 1/2"), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, "x 1"), /*#__PURE__*/React.createElement("option", {
          value: "1.5"
        }, "x 1.5"), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, "x 2"), /*#__PURE__*/React.createElement("option", {
          value: "3"
        }, "x 3"), /*#__PURE__*/React.createElement("option", {
          value: "5"
        }, "x 5"), /*#__PURE__*/React.createElement("option", {
          value: "10"
        }, "x 10")))), _this8.getInteractionAction(x).ActionType == ActionType.Vibration && [/*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionVibrationIntensity(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectIntensity)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectIntensity)
        }, /*#__PURE__*/React.createElement("option", {
          value: "0"
        }, intl.format(SequenceActionVibrationIntensity.Weak)), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, intl.format(SequenceActionVibrationIntensity.Medium)), /*#__PURE__*/React.createElement("option", {
          value: "2"
        }, intl.format(SequenceActionVibrationIntensity.Strong))))), /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionVibrationTime(i, e);
          },
          value: x.Actions[0].Scale
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTime)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTime)
        }, /*#__PURE__*/React.createElement("option", {
          value: "0.5"
        }, intl.format(Label.Seconds, {
          time: "0.5"
        })), /*#__PURE__*/React.createElement("option", {
          value: "1"
        }, intl.format(Label.Seconds, {
          time: "1.0"
        })), /*#__PURE__*/React.createElement("option", {
          value: "3"
        }, intl.format(Label.Seconds, {
          time: "3.0"
        })))))], _this8.getInteractionAction(x).ActionType == ActionType.SwitchGroup && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionScenarioGroup(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectScenarioGroup)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectScenarioGroup)
        }, /*#__PURE__*/React.createElement("option", {
          value: -1
        }, intl.format(PresetScenarioGroup.CurrentTop)), /*#__PURE__*/React.createElement("option", {
          value: -2
        }, intl.format(PresetScenarioGroup.PreviousTop)), /*#__PURE__*/React.createElement("option", {
          value: -3
        }, intl.format(PresetScenarioGroup.PreviousBranch)), _this8.state.SequenceTimeline.SequenceGroups.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.GroupNo
          }, z.GroupName);
        })))), x.Actions[0].Conditions.length > 0 && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }), x.Actions[0].Conditions.length > 0 && x.Actions[0].Conditions.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectWrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectRight"
          }, /*#__PURE__*/React.createElement("div", {
            className: "authoringCont__selectIcon"
          })), /*#__PURE__*/React.createElement("select", {
            className: "authoringCont__select",
            disabled: _this8.props.mode == Mode.ReadOnly || !x.Actions[0].Conditions[j].IsOn,
            onChange: function onChange(e) {
              _this8.updateActionConditionScenarioGroup(i, j, e);
            },
            value: x.Actions[0].Conditions[j].ActionValue
          }, /*#__PURE__*/React.createElement("option", {
            className: "placeholder"
          }, intl.format(Action.SelectScenarioGroup)), /*#__PURE__*/React.createElement("optgroup", {
            label: intl.format(Action.SelectScenarioGroup)
          }, /*#__PURE__*/React.createElement("option", {
            value: -1
          }, intl.format(PresetScenarioGroup.CurrentTop)), /*#__PURE__*/React.createElement("option", {
            value: -2
          }, intl.format(PresetScenarioGroup.PreviousTop)), /*#__PURE__*/React.createElement("option", {
            value: -3
          }, intl.format(PresetScenarioGroup.PreviousBranch)), _this8.state.SequenceTimeline.SequenceGroups.map(function (z, k) {
            return /*#__PURE__*/React.createElement("option", {
              value: z.GroupNo
            }, z.GroupName);
          }))));
        }), _this8.getInteractionMaterial(x).MaterialType == MaterialTypes.SphereGroup && (_this8.getInteractionAction(x).ActionType == ActionType.Visibility || _this8.getInteractionAction(x).ActionType == ActionType.Play) && _this8.getInteractionAction(x).IsOn && /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectRight"
        }, /*#__PURE__*/React.createElement("div", {
          className: "authoringCont__selectIcon"
        })), /*#__PURE__*/React.createElement("select", {
          className: "authoringCont__select",
          disabled: _this8.props.mode == Mode.ReadOnly,
          onChange: function onChange(e) {
            _this8.updateActionMotion(i, e);
          },
          value: x.Actions[0].MotionName
        }, /*#__PURE__*/React.createElement("option", {
          className: "placeholder"
        }, intl.format(Action.SelectTarget)), /*#__PURE__*/React.createElement("optgroup", {
          label: intl.format(Action.SelectTarget)
        }, _this8.getInteractionAction(x).ActionType == ActionType.Play && /*#__PURE__*/React.createElement("option", {
          value: "CURRENTLY_SELECTED"
        }, intl.format(SequenceActions.CurrentlySelected)), _this8.state.InteractionTimeline.Materials.filter(function (m) {
          return m.MaterialFileName == x.Actions[0].ObjectName;
        })[0].Items.map(function (z, k) {
          return /*#__PURE__*/React.createElement("option", {
            value: z.ItemName
          }, z.ItemName);
        }))))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn",
          style: {
            width: "40px"
          }
        }), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, _this8.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--insert",
          type: "button",
          onClick: _this8.insertInteraction.bind(_this8, i)
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/seqadd_icon.svg"
        })), _this8.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--insert",
          type: "button",
          disabled: true
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/seqadd_icon.svg"
        }))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, _this8.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--duplicate",
          type: "button",
          onClick: _this8.duplicateInteraction.bind(_this8, i)
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/clone_icon.svg"
        })), _this8.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--duplicate",
          type: "button",
          disabled: true
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/clone_icon.svg"
        }))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, _this8.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          type: "button",
          onClick: _this8.deleteInteraction.bind(_this8, i)
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon_red.svg"
        })), _this8.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          type: "button",
          disabled: true
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon_red.svg"
        })))));
      })), this.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__addBtn",
        type: "button",
        onClick: this.addInteraction.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.Add)))), this.props.mode == Mode.Modify && /*#__PURE__*/React.createElement("div", {
        className: "authoringFotter"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringFotter__normal__btn",
        type: "button",
        onClick: this.cancelModal.bind(this)
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        className: "authoringFotter__primary__btn",
        type: "button",
        onClick: this.saveModal.bind(this)
      }, intl.format(Action.Entry))), this.props.mode != Mode.Modify && /*#__PURE__*/React.createElement("div", {
        className: "authoringFotter"
      }, /*#__PURE__*/React.createElement("button", {
        className: "authoringFotter__primary__btn",
        type: "button",
        onClick: this.closeModal.bind(this)
      }, intl.format(Action.Close)))))))))), this.state.SessionAuthoringMemoModalMode != SessionAuthoringMemoModalComponent.Mode.None && /*#__PURE__*/React.createElement(SessionAuthoringMemoModalComponent["default"], {
        mode: this.state.SessionAuthoringMemoModalMode,
        memo: this.state.Sequence != null && this.state.Sequence.Memo != null ? this.state.Sequence.Memo : "",
        onEdit: this.editSessionAuthoringMemoModal.bind(this),
        onHidden: this.hiddenSessionAuthoringMemoModal.bind(this)
      }), this.state.SessionAuthoringConfirmModalMode != SessionAuthoringConfirmModalComponent.Mode.None && /*#__PURE__*/React.createElement(SessionAuthoringConfirmModalComponent["default"], {
        mode: this.state.SessionAuthoringConfirmModalMode,
        originalValue: this.state.CurrentGroup != null ? this.state.CurrentGroup.GroupNo == 1 ? this.state.CurrentGroup.GroupName.slice(0, -intl.format(AuthoringSequence.SequenceGroupDefaultPostfix).length) : this.state.CurrentGroup.GroupName : "",
        currentGroup: this.state.CurrentGroup,
        sequenceTimeline: this.state.SequenceTimeline,
        interactionTimeline: this.state.InteractionTimeline,
        onIgnore: this.ignoreSessionAuthoringConfirmModal.bind(this),
        onInput: this.inputSessionAuthoringConfirmModal.bind(this),
        onYes: this.yesSessionAuthoringConfirmModal.bind(this),
        onNo: this.noSessionAuthoringConfirmModal.bind(this),
        onHidden: this.hiddenSessionAuthoringConfirmModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };